/* Stand 23.10.2026: Stickfarben (6) + Tasbih (9 Farben) */
/* ═══════════════════════════════════════════════════════════
   Jannaty Konfigurator — Core JS
   Vollständig eigenständig, kein Third-Party App
   ═══════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  // ══ POSITION EINSTELLUNGEN ════════════════════════════════
  // Diese Werte steuern wo der Name auf dem Teppich erscheint.
  // Mit ?pos=1 in der URL erscheinen Schieberegler zum visuellen Einstellen.
  const NAME_POS = {
    x:    0.76,  // kalibriert: Adam(0.76) Vanessa(0.76) Mohammed(0.79→interpoliert)
    y:    0.67,  // kalibriert: Adam(0.68) Vanessa(0.66) Mohammed(0.64→interpoliert)
    r:    -55,   // kalibriert: -55° Durchschnitt
    size: 1.0,   // 1.0 = autoSize aktiv; anderer Wert = manuell (Slider)
  };

  // Symbol-Positions-Config
  const SYMBOL_POS = {
    x:    0.64,  // links vom Namen
    y:    0.72,
    r:    -55,
    size: 0.10,  // Anteil von canvas.width
  };

  // Spray Positions-Config
  const SPRAY_POS = {
    x:    0.06,
    y:    0.33,
    size: 0.34,
    r:    0,
  };

  // Tasbih Positions-Config
  const TASBIH_POS = {
    x:    0.28,
    y:    0.54,
    size: 0.31,
    r:    0,
  };

  // Arabische Positions-Config (separat von Lateinisch)
  const ARABIC_POS = {
    x:    0.71,
    y:    0.69,
    r:    -52,
    size: 0.130,  // kalibriert 18.04.2026
  };

  // ── Typ-B (Geschenkverpackung) Positions — separat kalibrierbar via ?pos=1 ──
  const NAME_POS_B   = { x: 0.00, y: 0.82, r: -1, size: 0.28, xRight: 0.86, xLeft: 0.27 };
  const ARABIC_POS_B = { x: 0.00, y: 0.82, r: -1, size: 0.130 };
  const SPRAY_POS_B  = { x: 0.02, y: 0.09, size: 0.49, r: -10 };
  const TASBIH_POS_B = { x: 0.43, y: 0.11, size: 0.40, r: 10 };
  const SYMBOL_POS_B = { x: 0.00, y: 0.82, r: -1, size: 0.10 };

  // Schleifenbereich — wird nach dem Text nochmal obendrauf gezeichnet (Text geht "drunter")
  const BOW_POS = { x: 0.37, y: 0.70, w: 0.13, h: 0.14 };

  // Auto-Größe & Auto-Position aus Kalibrierdaten (Adam/Vanessa/Mohammed)
  // Vanessa(7)=0.26✓  Adam(4)=0.26✓  Mohammed(8)=0.21✓
  function autoSize(name) {
    const len = (name || '').replace(/\s/g, '').length;
    return Math.max(0.19, 0.26 - Math.max(0, len - 6) * 0.012);
  }
  // Längere Namen leicht nach rechts & oben verschieben
  function autoPosX(name, pos) {
    pos = pos || NAME_POS;
    const len = (name || '').replace(/\s/g, '').length;
    return pos.x + Math.max(0, len - 7) * 0.015;
  }
  function autoPosY(name, pos) {
    pos = pos || NAME_POS;
    const len = (name || '').replace(/\s/g, '').length;
    return pos.y - Math.max(0, len - 7) * 0.015;
  }
  // ═════════════════════════════════════════════════════════

  // Schätzt halbe Breite des Namens — spiegelt drawMadameName exakt
  // Damit das Symbol immer am Ende des Namens positioniert wird
  const _GLYPH_W = {
    'A':348,'B':308,'C':203,'D':309,'E':228,'F':322,'G':302,'H':423,'I':300,
    'J':365,'K':373,'L':303,'M':418,'N':377,'O':217,'P':298,'Q':230,'R':317,
    'S':221,'T':335,'U':286,'V':250,'W':313,'X':347,'Y':326,'Z':338,
    '3':410,
    'a':155,'b':126,'c':123,'d':195,'e':119,'f':307,'g':224,'h':175,'i':108,
    'j':240,'k':172,'l':133,'m':236,'n':174,'o':132,'p':277,'q':155,'r':152,
    's':139,'t':141,'u':152,'v':124,'w':185,'x':158,'y':216,'z':156,
  };
  const _GLYPH_K = { 'd':0.60, 'i':0.58, 'l':0.48, 'm':0.86, 'y':0.58 };

  function estimateLatinHalfWidth(name, W, sizeMult) {
    const KERN = 0.78, PAD = 4, REF_H = 247;
    const CAP_H = W * 0.356 * (sizeMult || 1);
    const SCALE = CAP_H / REF_H;
    const maxWidth = W * 0.80;
    // Same normalization as _normalizeName
    const norm = (name || '')
      .replace(/ß/g, 'ss').replace(/Ö/g,'O').replace(/ö/g,'o')
      .replace(/Ä/g,'A').replace(/ä/g,'a').replace(/Ü/g,'U').replace(/ü/g,'u');
    let totalW = 0;
    for (const c of norm) {
      if (c === ' ') { totalW += 50; continue; }
      const gw = _GLYPH_W[c] || 200;
      totalW += (gw + PAD * 2) * SCALE * (_GLYPH_K[c] !== undefined ? _GLYPH_K[c] : KERN);
    }
    const gs = totalW > maxWidth ? maxWidth / totalW : 1;
    return (totalW * gs) / 2;
  }

  function estimateArabicHalfWidth(name, W, sizeMult) {
    // Rough estimate: fontSize * chars * ~0.65 average advance ratio
    const fontSize = W * (sizeMult || ARABIC_POS.size);
    const len = (name || '').length;
    const rawWidth = len * fontSize * 0.65;
    const maxWidth = W * 0.75;
    return Math.min(rawWidth, maxWidth) / 2;
  }

  // ── Exakte CDN URLs (von Shopify nach Upload) ─────────────
  const CDN_URLS = {
    'typa-obsidian.jpeg':    'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/typa-obsidian.jpg?v=1776024349',
    'typa-mitternacht.jpeg': 'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/typa-mitternacht.jpg?v=1776024351',
    'typa-saphir.jpeg':      'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/typa-saphir.jpg?v=1776024353',
    'typa-steingrau.jpeg':   'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/typa-steingrau.jpg?v=1776024354',
    'typa-platin.jpeg':      'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/typa-platin.jpg?v=1776024357',
    'typa-alabaster.jpeg':   'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/typa-alabaster.jpg?v=1776024359',
    'typa-smaragd.jpeg':     'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/typa-smaragd.jpg?v=1776024361',
    'typa-granat.jpeg':      'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/typa-granat.jpg?v=1776024362',
    'typa-amethyst.jpeg':    'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/typa-amethyst.jpg?v=1776024363',
    'typa-kaschmir.jpeg':    'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/typa-kaschmir.jpg?v=1776024366',
    'typa-altrosa.jpeg':     'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/typa-altrosa.jpg?v=1776024367',
    'typa-rosenquarz.jpeg':  'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/typa-rosenquarz.jpg?v=1776024368',
    'typb-obsidian.jpeg':    'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/typb-obsidian.png?v=1777006066',
    'typb-mitternacht.jpeg': 'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/typb-mitternacht.png?v=1777006068',
    'typb-saphir.jpeg':      'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/typb-saphir.png?v=1777006070',
    'typb-steingrau.jpeg':   'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/typb-steingrau.png?v=1777006072',
    'typb-platin.jpeg':      'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/typb-platin.png?v=1777006073',
    'typb-alabaster.jpeg':   'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/typb-alabaster.png?v=1777006079',
    'typb-smaragd.jpeg':     'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/typb-smaragd.png?v=1777006077',
    'typb-granat.jpeg':      'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/typb-granat.png?v=1777006079',
    'typb-amethyst.jpeg':    'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/typb-amethyst.png?v=1777006080',
    'typb-kaschmir.jpeg':    'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/typb-kaschmir.png?v=1777006082',
    'typb-altrosa.jpeg':     'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/typb-altrosa.png?v=1777006083',
    'typb-rosenquarz.jpeg':  'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/typb-rosenquarz.png?v=1777006086',
    // 23.10.2026: neue Tasbih-Bilder (9 echte Farben, freigestellt, 2048x2048, gleiche Lage wie die alten)
    'tasbih-gold.png':       'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/tasbih-2026-10-gold.png?v=1792781693',
    'tasbih-weiss.png':      'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/tasbih-2026-10-weiss.png?v=1792781700',
    'tasbih-schwarz.png':    'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/tasbih-2026-10-schwarz.png?v=1792781707',
    'tasbih-blau.png':       'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/tasbih-2026-10-blau.png?v=1792781714',
    'tasbih-babyblau.png':   'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/tasbih-2026-10-babyblau.png?v=1792781721',
    'tasbih-gruen.png':      'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/tasbih-2026-10-gruen.png?v=1792781728',
    'tasbih-rosa.png':       'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/tasbih-2026-10-rosa.png?v=1792781735',
    'tasbih-lila.png':       'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/tasbih-2026-10-lila.png?v=1792781743',
    'tasbih-rot.png':        'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/tasbih-2026-10-rot.png?v=1792781750',
    'spray-haya.png': 'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/spray-haya.png?v=1791748069',
    'spray-maahir.png': 'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/spray-maahir.png?v=1791748040',
    'spray-salted-caramel-macaron.png': 'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/spray-salted-caramel-macaron.png?v=1791748054',
    'spray-emaan.png': 'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/spray-emaan.png?v=1791748061',
    'spray-the-kingdom.png': 'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/spray-the-kingdom.png?v=1791748047',
    'spray-rose-petal-macaron.png': 'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/spray-rose-petal-macaron.png?v=1791748075',
    'font-alexbrush.ttf':    'https://cdn.shopify.com/s/files/1/1061/3093/2050/t/1/assets/font-alexbrush.ttf?v=1776201732',
    'font-reemkufi.ttf':     'https://cdn.shopify.com/s/files/1/1061/3093/2050/t/1/assets/Mada-Regular.ttf?v=1776281570',
  };
  const CDN = 'https://cdn.shopify.com/s/files/1/1061/3093/2050/files/';

  // ── Farben ────────────────────────────────────────────────
  const COLORS = [
    { key: 'obsidian',    label: 'Obsidian',    hex: '#141414', variantId: 53017633784146 },
    { key: 'mitternacht', label: 'Mitternacht', hex: '#1C2E4A', variantId: 53017633849682 },
    { key: 'saphir',      label: 'Saphir',      hex: '#1E4DB7', variantId: 53180959293778 },
    { key: 'steingrau',   label: 'Steingrau',   hex: '#606060', variantId: 53017633882450 },
    { key: 'platin',      label: 'Platin',      hex: '#A0A0A0', variantId: 53017634046290 },
    { key: 'alabaster',   label: 'Alabaster',   hex: '#F5F0E8', variantId: 53017633816914 },
    { key: 'smaragd',     label: 'Smaragd',     hex: '#1B4D3E', variantId: 53017633947986 },
    { key: 'granat',      label: 'Granat',      hex: '#6B1A2A', variantId: 53017633980754 },
    { key: 'amethyst',    label: 'Amethyst',    hex: '#4A2060', variantId: 53017634079058 },
    { key: 'kaschmir',    label: 'Kaschmir',    hex: '#C8B090', variantId: 53017634013522 },
    { key: 'altrosa',     label: 'Altrosa',     hex: '#D4A0A0', variantId: 53017633915218 },
    { key: 'rosenquarz',  label: 'Rosenquarz',  hex: '#E87BA0', variantId: 53180959359314 },
  ];

  // ── Stickfarben ────────────────────────────────────────────
  const YARN = [
    // 23.10.2026: echte Garnfarben laut User (Bronze, Weiß, Smaragdgrün entfallen; Rosenquarz -> Rosa, Nude -> Nude-Beige)
    // 25.10.2026: Anzeige "Nude-Beige" -> "Beige" (User); Schlüssel 'nude' bleibt für bestehende Bestellungen/Bilder
    { key: 'gold',    label: 'Gold',       hex: '#D4AF37' },
    { key: 'silber',  label: 'Silber',     hex: '#C0C0C0' },
    { key: 'taupe',   label: 'Taupe',      hex: '#8C7B6B' },
    { key: 'nude',    label: 'Beige',      hex: '#D8B4A0' },
    { key: 'schwarz', label: 'Schwarz',    hex: '#1A1A1A' },
    { key: 'rosa',    label: 'Rosa',       hex: '#F2B5C4' },
  ];

  // ── Tasbih ────────────────────────────────────────────────
  const TASBIH = [
    // 23.10.2026: dieselben 9 Farben wie das Tasbih-Produkt (Grau/Türkis entfallen, Türkis = Babyblau)
    { key: 'gold',     label: 'Gold',     img: CDN_URLS['tasbih-gold.png'] + '&width=768' },
    { key: 'weiss',    label: 'Weiß',     img: CDN_URLS['tasbih-weiss.png'] + '&width=768' },
    { key: 'schwarz',  label: 'Schwarz',  img: CDN_URLS['tasbih-schwarz.png'] + '&width=768' },
    { key: 'blau',     label: 'Blau',     img: CDN_URLS['tasbih-blau.png'] + '&width=768' },
    { key: 'babyblau', label: 'Babyblau', img: CDN_URLS['tasbih-babyblau.png'] + '&width=768' },
    { key: 'gruen',    label: 'Grün',     img: CDN_URLS['tasbih-gruen.png'] + '&width=768' },
    { key: 'rosa',     label: 'Rosa',     img: CDN_URLS['tasbih-rosa.png'] + '&width=768' },
    { key: 'lila',     label: 'Lila',     img: CDN_URLS['tasbih-lila.png'] + '&width=768' },
    { key: 'rot',      label: 'Rot',      img: CDN_URLS['tasbih-rot.png'] + '&width=768' },
  ];

  // ── Sprays ────────────────────────────────────────────────
  const SPRAYS = [
    { key: 'haya',                   label: 'Haya',                   img: CDN_URLS['spray-haya.png'] + '&width=768' },
    { key: 'maahir',                 label: 'Maahir',                 img: CDN_URLS['spray-maahir.png'] + '&width=768' },
    { key: 'salted-caramel-macaron', label: 'Salted Caramel Macaron', img: CDN_URLS['spray-salted-caramel-macaron.png'] + '&width=768' },
    { key: 'emaan',                  label: 'Emaan',                  img: CDN_URLS['spray-emaan.png'] + '&width=768' },
    { key: 'the-kingdom',            label: 'The Kingdom',            img: CDN_URLS['spray-the-kingdom.png'] + '&width=768' },
    { key: 'rose-petal-macaron',     label: 'Rose Petal Macaron',     img: CDN_URLS['spray-rose-petal-macaron.png'] + '&width=768' },
  ];

  // ── Preise ────────────────────────────────────────────────
  const PRICES = {
    base:           24.99,
    name1:           9.99,
    name2:           6.99,
    symbol:          3.99,
    tasbih:          6.99,
    spray:           7.99,
    geschenkverp:    3.99,
  };

  // ── Geschenkset-Angebot (nur Deutschland) ─────────────────
  const SET_PRICE = 49.90;   // Höchstpreis inkl. Teppich + Versand, sobald die Geschenkverpackung gewählt ist (Regel seit 28.10.2026)
  // 01.11.2026 Weg B (wie Molora): jedes Extra ist ein eigener versteckter Artikel mit Symbolbild + eigenem Preis (Tag „jn-extra“).
  // Varianten-IDs aus _SHOP/_extras_icons/extras.json. Set-Preis 49,90 € rechnet der Rabatt „GESCHENKSET“ (App jannaty-ein-artikel).
  // Alter Sammel-Aufpreis (ADDON, Produkt „Personalisierung Sajadah“): _BACKUP_WEG_B_2026-11-01
  const EXTRAS = {"name": 55301417959762, "symbol": {"herz": 55301418189138, "halbmond": 55301418221906, "unendlich": 55301418254674}, "tasbih": {"gold": 55301419794770, "weiss": 55301419827538, "schwarz": 55301419860306, "blau": 55301419893074, "babyblau": 55301419925842, "gruen": 55301419958610, "rosa": 55301419991378, "lila": 55301420024146, "rot": 55301420056914}, "spray": {"haya": 55301421334866, "maahir": 55301421367634, "salted-caramel-macaron": 55301421400402, "emaan": 55301421433170, "the-kingdom": 55301421465938, "rose-petal-macaron": 55301421498706}, "geschenk": 55301423169874};
  function isDE() {
    try { return !!(window.Shopify && window.Shopify.country === 'DE'); } catch (e) { return false; }
  }
  // Echte Versandpauschalen je Land (Stand 23.09.2026, siehe Shopify-Versandprofil). Nur Laender mit Gratis-Versand-Schwelle.
  const SHIP_INFO = {
    DE: { fee: 6.49, thr: 49.90 },   // 01.11.2026: 6,49 statt 4,95 (User: echte Kosten pro DHL-Paket)
    AT: { fee: 5.99, thr: 59.90 },
    CH: { fee: 13.99, thr: 69.90 },
    BE: { fee: 13.99, thr: 69.90 }, BG: { fee: 13.99, thr: 69.90 }, HR: { fee: 13.99, thr: 69.90 }, CY: { fee: 13.99, thr: 69.90 },
    CZ: { fee: 13.99, thr: 69.90 }, DK: { fee: 13.99, thr: 69.90 }, EE: { fee: 13.99, thr: 69.90 }, FI: { fee: 13.99, thr: 69.90 },
    FR: { fee: 13.99, thr: 69.90 }, GR: { fee: 13.99, thr: 69.90 }, HU: { fee: 13.99, thr: 69.90 }, IE: { fee: 13.99, thr: 69.90 },
    IT: { fee: 13.99, thr: 69.90 }, LV: { fee: 13.99, thr: 69.90 }, LT: { fee: 13.99, thr: 69.90 }, LU: { fee: 13.99, thr: 69.90 },
    MT: { fee: 13.99, thr: 69.90 }, NL: { fee: 13.99, thr: 69.90 }, PL: { fee: 13.99, thr: 69.90 }, PT: { fee: 13.99, thr: 69.90 },
    RO: { fee: 13.99, thr: 69.90 }, SK: { fee: 13.99, thr: 69.90 }, SI: { fee: 13.99, thr: 69.90 }, ES: { fee: 13.99, thr: 69.90 }, SE: { fee: 13.99, thr: 69.90 },
  };
  function shipInfo() {
    try {
      const c = window.Shopify && window.Shopify.country;
      return (c && SHIP_INFO[c]) ? Object.assign({ country: c }, SHIP_INFO[c]) : null;
    } catch (e) { return null; }
  }
  function fmt(n) { return n.toFixed(2).replace('.', ',') + ' €'; }
  function hasSecondName() {
    return !!(state.name2enabled && state.name1 && state.name1.trim() && state.name2 && state.name2.trim());
  }

  // ── State ─────────────────────────────────────────────────
  const state = {
    currentStep: 0,
    color:        'obsidian',
    yarn:         'gold',
    font:         'latin',   // 'latin' | 'arabic'
    name1:        '',
    name2:        '',
    name2enabled: false,
    symbol:       null,      // null | 'halbmond' | 'herz' | 'unendlich'
    tasbih:       null,
    spray:        null,
    geschenkverp: false,
  };

  const NAME2_B_LEFT = 0.535;  // Geschenkpaket: linke Grenze der Zeile mit zwei Namen (rechts neben der Schleife)
  const NAME2_END_X = 0.94;   // Zeile mit zwei Namen endet spätestens hier (Anteil der Bildbreite)

  // ── Steps Definition ──────────────────────────────────────
  const STEPS = [
    'garnfarbe',
    'schriftart',
    'name1',
    'symbol',
    'tasbih',
    'spray',
    'geschenkverp',
  ];
  const TOTAL_STEPS = STEPS.length;

  // ── Canvas Setup ──────────────────────────────────────────
  let canvas, ctx;
  const imgCache = {};
  let fontsLoaded = false;

  // ── DOM References ────────────────────────────────────────
  let overlay, popup, configPanel, previewLabel;

  // ── Image Preloader ───────────────────────────────────────
  function loadImage(src) {
    if (imgCache[src]) return Promise.resolve(imgCache[src]);
    return new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => { imgCache[src] = img; resolve(img); };
      img.onerror = () => resolve(null);
      img.src = src;
    });
  }

  // ── Font Loader ───────────────────────────────────────────
  async function loadFonts() {
    if (fontsLoaded) return;
    try {
      const latin = new FontFace('AlexBrush', `url(${CDN_URLS['font-alexbrush.ttf']})`);
      const arabic = new FontFace('ReemKufi', `url(${CDN_URLS['font-reemkufi.ttf']})`);
      await Promise.all([latin.load(), arabic.load()]);
      document.fonts.add(latin);
      document.fonts.add(arabic);
      fontsLoaded = true;
    } catch (e) {
      console.warn('Font-Ladefehler:', e);
    }
  }

  // Lädt Typ-B-Bild für aktuelle Farbe im Hintergrund vor
  function preloadTypB() {
    const src = CDN_URLS[`typb-${state.color}.jpeg`];
    if (src && !imgCache[src]) loadImage(src);
  }

  // ── Canvas Renderer ───────────────────────────────────────
  async function renderCanvas() {
    if (!canvas || !ctx) return;

    // B-Positions-Aliases: je nach Modus A oder B-Konstanten verwenden
    const useB   = state.geschenkverp;
    const _NP    = useB ? NAME_POS_B   : NAME_POS;
    const _AP    = useB ? ARABIC_POS_B : ARABIC_POS;
    const _SP    = useB ? SPRAY_POS_B  : SPRAY_POS;
    const _TP    = useB ? TASBIH_POS_B : TASBIH_POS;
    const _SYMP  = useB ? SYMBOL_POS_B : SYMBOL_POS;

    // Background image — Typ-B wenn Geschenkverpackung, sonst Typ-A
    const imgKey = useB ? 'typb' : 'typa';
    const bgSrc = CDN_URLS[`${imgKey}-${state.color}.jpeg`];
    const bgImg = await loadImage(bgSrc);

    if (bgImg) {
      // Contain-Fit: Canvas passt sich dem Bild-Seitenverhältnis an — kein Cropping
      // Genau wie <img width="100%" height="auto"> bei Typ-C
      canvas.width  = bgImg.width;
      canvas.height = bgImg.height;
    } else {
      canvas.width  = 450;
      canvas.height = 600;
    }

    const W = canvas.width;
    const H = canvas.height;
    ctx.clearRect(0, 0, W, H);

    if (bgImg) {
      ctx.drawImage(bgImg, 0, 0, W, H);
    } else {
      ctx.fillStyle = COLORS.find(c => c.key === state.color)?.hex || '#888';
      ctx.fillRect(0, 0, W, H);
    }

    // Tasbih Overlay
    if (state.tasbih) {
      const t = TASBIH.find(t => t.key === state.tasbih);
      if (t) {
        const tImg = await loadImage(t.img);
        if (tImg) {
          const tw = W * _TP.size;
          const th = (tImg.height / tImg.width) * tw;
          const tcx = W * _TP.x + tw / 2, tcy = H * _TP.y + th / 2;
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = 'high';
          ctx.globalAlpha = 0.93;
          ctx.filter = 'drop-shadow(2px 5px 9px rgba(0,0,0,0.38))';
          ctx.save();
          ctx.translate(tcx, tcy);
          ctx.rotate((_TP.r || 0) * Math.PI / 180);
          ctx.drawImage(tImg, -tw / 2, -th / 2, tw, th);
          ctx.restore();
          ctx.filter = 'none';
          ctx.globalAlpha = 1;
        }
      }
    }

    // Spray Overlay
    if (state.spray) {
      const s = SPRAYS.find(s => s.key === state.spray);
      if (s) {
        const sImg = await loadImage(s.img);
        if (sImg) {
          const sw2 = W * _SP.size;
          const sh2 = (sImg.height / sImg.width) * sw2;
          const scx = W * _SP.x + sw2 / 2, scy = H * _SP.y + sh2 / 2;
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = 'high';
          ctx.globalAlpha = 0.93;
          ctx.filter = 'drop-shadow(2px 5px 9px rgba(0,0,0,0.38))';
          ctx.save();
          ctx.translate(scx, scy);
          ctx.rotate((_SP.r || 0) * Math.PI / 180);
          ctx.drawImage(sImg, -sw2 / 2, -sh2 / 2, sw2, sh2);
          ctx.restore();
          ctx.filter = 'none';
          ctx.globalAlpha = 1;
        }
      }
    }

    // Text — Name(n)
    const yarnColor = YARN.find(y => y.key === state.yarn)?.hex || '#D4AF37';
    const isArabic  = state.font === 'arabic';

    // Zeile mit beiden Namen: 1. Name + Unendlich-Zeichen + 2. Name (Glyph '3' der Stickschrift)
    const twoNames = hasSecondName();
    const lineText = twoNames ? state.name1 + '3' + state.name2 : state.name1;

    // Auto-Position: feste Werte + leichte Anpassung für längere Namen
    const px1 = autoPosX(lineText, _NP), py1 = autoPosY(lineText, _NP);
    const rad = _NP.r * Math.PI / 180;

    // Schieberegler überschreiben die Auto-Position wenn sie bewegt wurden
    const defX = 0.76, defY = 0.67;
    const usedNx1 = W * (_NP.x !== defX ? _NP.x : px1);
    const usedNy1 = H * (_NP.y !== defY ? _NP.y : py1);

    // Arabische Position
    const arabRad = _AP.r * Math.PI / 180;
    // Geschenkpaket: arabische Zeile in die Zone rechts neben der Schleife (die Paket-Position war nie kalibriert, x = 0)
    const aNx1 = W * (useB ? (NAME2_B_LEFT + _NP.xRight) / 2 : _AP.x), aNy1 = H * _AP.y;
    const arabMaxW = useB ? W * (_NP.xRight - NAME2_B_LEFT) : W * 0.75;
    const aNx2 = W * _AP.x, aNy2 = H * (_AP.y + 0.11);

    let arabLay = null;   // Zeilenaufteilung bei zwei Namen (arabisch, von rechts nach links)
    if (isArabic) {
      if (twoNames) {
        let fs = Math.round(W * _AP.size);
        const maxW = arabMaxW;
        let w1, w2, gap, sSz, total;
        for (;;) {
          ctx.font = `${fs}px "ReemKufi"`;
          w1 = ctx.measureText(state.name1).width; w2 = ctx.measureText(state.name2).width;
          gap = fs * 0.22; sSz = fs * 0.72; total = w1 + w2 + 2 * gap + sSz;
          if (total <= maxW || fs <= 12) break;
          fs -= 2;
        }
        arabLay = { fs, w1, w2, gap, sSz, total };
      }
      ctx.save();
      ctx.translate(aNx1, aNy1); ctx.rotate(arabRad); ctx.translate(-aNx1, -aNy1);
      ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      if (arabLay) {
        const L = arabLay;
        const c1 = aNx1 + L.total / 2 - L.w1 / 2;                       // 1. Name rechts
        const cs = aNx1 + L.total / 2 - L.w1 - L.gap - L.sSz / 2;       // Unendlich in der Mitte
        const c2 = aNx1 - L.total / 2 + L.w2 / 2;                       // 2. Name links
        drawEmbroideryText(state.name1, c1, aNy1, 'ReemKufi', yarnColor, W * 3, true, L.fs / W);
        drawEmbroideryText(state.name2, c2, aNy1, 'ReemKufi', yarnColor, W * 3, true, L.fs / W);
        drawSymbol('unendlich', cs, aNy1 - L.fs * 0.12, yarnColor, L.sSz);
      } else if (state.name1) {
        drawEmbroideryText(state.name1, aNx1, aNy1, 'ReemKufi', yarnColor, arabMaxW, true);
      }
      ctx.restore();
    } else {
      const SYMBOL_CHAR = {herz:'1', halbmond:'2', unendlich:'3'};
      const symChar = state.symbol ? (SYMBOL_CHAR[state.symbol] || '') : '';

      if (useB) {
        // Typ-B: rechtsbündig von xRight — längere Namen wachsen nach links unter die Schleife
        const xRightPx = W * _NP.xRight;
        // Zwei Namen: Zeile bleibt rechts neben der Schleife (sonst würde die Schleife Buchstaben und das ∞ verdecken)
        const xLeftPx  = W * (twoNames ? NAME2_B_LEFT : _NP.xLeft);
        const maxAllowedW = xRightPx - xLeftPx;

        if (state.name1) {
          const fullText = lineText + symChar;
          // Größe reduzieren falls die Zeile die linke Grenze überschreiten würde
          let sz1 = _NP.size;
          for (let it = 0; it < 4; it++) {   // schrittweise verkleinern (die Schätzung ist bei sehr langen Zeilen gedeckelt)
            const estW1 = estimateLatinHalfWidth(fullText, W, sz1) * 2;
            if (estW1 <= maxAllowedW * 1.001) break;
            sz1 = sz1 * (maxAllowedW / estW1);
          }
          const halfW1 = estimateLatinHalfWidth(fullText, W, sz1);
          const centerX1 = xRightPx - halfW1;
          const ny = H * _NP.y;
          ctx.save();
          ctx.translate(centerX1, ny); ctx.rotate(rad); ctx.translate(-centerX1, -ny);
          await drawMadameName(ctx, fullText, centerX1, ny, yarnColor, maxAllowedW, sz1);
          ctx.restore();
        }
        // Schleifenmaske: bgImg nochmal über den Schleifenbereich zeichnen → Text geht "drunter"
        const bx = W * BOW_POS.x, by = H * BOW_POS.y;
        const bw = W * BOW_POS.w, bh = H * BOW_POS.h;
        ctx.save();
        ctx.beginPath();
        ctx.rect(bx, by, bw, bh);
        ctx.clip();
        ctx.drawImage(bgImg, 0, 0, W, H);
        ctx.restore();
      } else {
        // Typ-A: normales Rendering mit autoSize
        if (state.name1) {
          ctx.save();
          ctx.translate(usedNx1, usedNy1); ctx.rotate(rad); ctx.translate(-usedNx1, -usedNy1);
          if (twoNames) {
            // Zwei Namen: Startpunkt der Zeile bleibt wie bei den kalibrierten Einzelnamen, die Zeile wächst
            // entlang des Randes nach oben rechts und wird gemeinsam verkleinert, damit sie im Bild bleibt.
            ctx.restore();
            const SZ2 = 0.26;
            const L7  = estimateLatinHalfWidth('Vanessa', W, SZ2) * 2;
            const cx7 = W * (_NP.x !== defX ? _NP.x : autoPosX('Vanessa', _NP));
            const cy7 = H * (_NP.y !== defY ? _NP.y : autoPosY('Vanessa', _NP));
            const dx = Math.cos(rad), dy = Math.sin(rad);
            const sx = cx7 - dx * L7 / 2, sy = cy7 - dy * L7 / 2;
            const Lmax = Math.min(W * 0.80, (W * NAME2_END_X - sx) / dx);
            const fullText2 = lineText + symChar;
            const L = Math.min(estimateLatinHalfWidth(fullText2, W, SZ2) * 2, Lmax);
            const cx = sx + dx * L / 2, cy = sy + dy * L / 2;
            ctx.save();
            ctx.translate(cx, cy); ctx.rotate(rad); ctx.translate(-cx, -cy);
            await drawMadameName(ctx, fullText2, cx, cy, yarnColor, Lmax, SZ2);
            ctx.restore();
            ctx.save();   // Klammer für das gemeinsame ctx.restore() unten
          } else {
            const s1 = _NP.size !== 1.0 ? _NP.size : autoSize(lineText);
            await drawMadameName(ctx, lineText + symChar, usedNx1, usedNy1, yarnColor, W * 0.80, s1);
          }
          ctx.restore();
        } else if (symChar) {
          const sx = W * _SYMP.x, sy = H * _SYMP.y;
          ctx.save();
          ctx.translate(sx, sy); ctx.rotate(rad); ctx.translate(-sx, -sy);
          drawSymbol(state.symbol, sx, sy, yarnColor, W * _SYMP.size);
          ctx.restore();
        }
      }
    }

    // Symbol (Arabisch) — direkt am Text-Ende (links, da RTL)
    if (state.symbol && isArabic) {
      let arabFontSize = Math.round(W * _AP.size);
      ctx.font = `${arabFontSize}px "ReemKufi"`;
      while (ctx.measureText(state.name1 || '').width > arabMaxW && arabFontSize > 12) {
        arabFontSize -= 2;
        ctx.font = `${arabFontSize}px "ReemKufi"`;
      }
      let textHalfW = ctx.measureText(state.name1 || '').width / 2;
      if (arabLay) { arabFontSize = arabLay.fs; textHalfW = arabLay.total / 2; }
      const sSize = arabFontSize * 0.72;
      const gap = arabFontSize * 0.13;
      const symX = aNx1 - textHalfW - gap - sSize * 0.5;
      const symY = aNy1 - arabFontSize * 0.12;
      ctx.save();
      ctx.translate(aNx1, aNy1); ctx.rotate(arabRad); ctx.translate(-aNx1, -aNy1);
      drawSymbol(state.symbol, symX, symY, yarnColor, sSize);
      ctx.restore();
    }

    // Preview Label
    if (previewLabel) {
      previewLabel.textContent = state.geschenkverp
        ? 'Geschenkset-Vorschau'
        : 'Personalisierungsvorschau';
    }
  }

  // ── Symbol Renderer ───────────────────────────────────────
  function drawSymbol(type, cx, cy, color, size) {
    const oc = document.createElement('canvas');
    const pad = size * 0.6;
    oc.width = Math.ceil(size * 2.4 + pad * 2);
    oc.height = Math.ceil(size * 2.4 + pad * 2);
    const oc2 = oc.getContext('2d');
    const ocx = oc.width / 2, ocy = oc.height / 2;

    // 1. Symbol-Form zeichnen
    oc2.fillStyle = color;
    oc2.strokeStyle = color;
    if (type === 'halbmond')  _pathHalbmond(oc2, ocx, ocy, size);
    if (type === 'herz')      _pathHerz(oc2, ocx, ocy, size);
    if (type === 'unendlich') _pathUnendlich(oc2, ocx, ocy, size);

    // 2. Satin-Stich-Linien (source-atop = nur innerhalb der Form)
    oc2.globalCompositeOperation = 'source-atop';
    const sp = Math.max(2.5, size * 0.065);
    oc2.lineWidth = sp * 0.5;
    for (let ly = 0; ly < oc.height; ly += sp) {
      oc2.beginPath();
      oc2.strokeStyle = (Math.round(ly / sp) % 2 === 0)
        ? 'rgba(255,255,255,0.28)' : 'rgba(0,0,0,0.13)';
      oc2.moveTo(0, ly); oc2.lineTo(oc.width, ly); oc2.stroke();
    }

    // 3. Shimmer
    const grad = oc2.createLinearGradient(oc.width * 0.1, 0, oc.width * 0.75, oc.height);
    grad.addColorStop(0,    'rgba(255,255,255,0)');
    grad.addColorStop(0.42, 'rgba(255,255,255,0.20)');
    grad.addColorStop(0.58, 'rgba(255,255,255,0.20)');
    grad.addColorStop(1,    'rgba(255,255,255,0)');
    oc2.fillStyle = grad;
    oc2.fillRect(0, 0, oc.width, oc.height);

    // 4. Auf Haupt-Canvas mit Schatten
    ctx.save();
    ctx.shadowColor = 'rgba(0,0,0,0.45)';
    ctx.shadowBlur = 4;
    ctx.shadowOffsetX = 0.5;
    ctx.shadowOffsetY = 2.5;
    ctx.drawImage(oc, cx - oc.width / 2, cy - oc.height / 2);
    ctx.restore();
  }

  function _pathHalbmond(oc2, cx, cy, size) {
    const r = size * 0.48;
    // Voller Kreis
    oc2.beginPath(); oc2.arc(cx, cy, r, 0, Math.PI * 2); oc2.fill();
    // Überlappenden Kreis ausschneiden → Halbmond
    oc2.globalCompositeOperation = 'destination-out';
    oc2.beginPath(); oc2.arc(cx + r * 0.42, cy - r * 0.08, r * 0.80, 0, Math.PI * 2); oc2.fill();
    oc2.globalCompositeOperation = 'source-over';
  }

  function _pathHerz(oc2, cx, cy, size) {
    const s = size * 0.52;
    oc2.beginPath();
    oc2.moveTo(cx, cy + s * 0.75);
    oc2.bezierCurveTo(cx - s, cy + s * 0.35, cx - s, cy - s * 0.4, cx - s * 0.5, cy - s * 0.4);
    oc2.bezierCurveTo(cx - s * 0.2, cy - s * 0.4, cx, cy - s * 0.15, cx, cy);
    oc2.bezierCurveTo(cx, cy - s * 0.15, cx + s * 0.2, cy - s * 0.4, cx + s * 0.5, cy - s * 0.4);
    oc2.bezierCurveTo(cx + s, cy - s * 0.4, cx + s, cy + s * 0.35, cx, cy + s * 0.75);
    oc2.fill();
  }

  function _pathUnendlich(oc2, cx, cy, size) {
    const lw = size * 0.22;
    oc2.lineWidth = lw;
    oc2.lineCap = 'round';
    oc2.lineJoin = 'round';
    // Lemniskate über Parameterkurve
    const steps = 120;
    oc2.beginPath();
    for (let i = 0; i <= steps; i++) {
      const t = (i / steps) * Math.PI * 2;
      const denom = 1 + Math.sin(t) * Math.sin(t);
      const px = cx + (size * 0.55 * Math.cos(t)) / denom;
      const py = cy + (size * 0.55 * Math.sin(t) * Math.cos(t)) / denom;
      i === 0 ? oc2.moveTo(px, py) : oc2.lineTo(px, py);
    }
    oc2.stroke();
  }

  function drawEmbroideryText(text, x, y, fontFamily, color, maxWidth, isRTL, sizeMult) {
    // Proportionale Startgröße (wie Madame-Font)
    let fontSize = Math.round(canvas.width * (sizeMult || ARABIC_POS.size));
    ctx.font = `${fontSize}px "${fontFamily}"`;
    while (ctx.measureText(text).width > maxWidth && fontSize > 12) {
      fontSize -= 2;
      ctx.font = `${fontSize}px "${fontFamily}"`;
    }

    const W = canvas.width;
    const H = canvas.height;
    const fontStr = `${fontSize}px "${fontFamily}"`;

    // ── 1. Schatten-Schicht (dunkler Versatz, wie Madame-Embroidery) ──
    ctx.save();
    ctx.font = fontStr;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = darkenColor(color, 0.55);
    ctx.shadowColor = 'rgba(0,0,0,0.35)';
    ctx.shadowBlur  = fontSize * 0.05;
    ctx.shadowOffsetX = fontSize * 0.04;
    ctx.shadowOffsetY = fontSize * 0.05;
    ctx.fillText(text, x + fontSize * 0.045, y + fontSize * 0.055);
    ctx.restore();

    // ── 2. Satin-Stich-Schicht auf Offscreen-Canvas ──────────────────
    const ofc = document.createElement('canvas');
    ofc.width = W; ofc.height = H;
    const ofx = ofc.getContext('2d');

    ofx.font = fontStr;
    ofx.textAlign = 'center';
    ofx.textBaseline = 'middle';

    // Buchstabenform als Basis füllen
    ofx.fillStyle = color;
    ofx.fillText(text, x, y);

    // Diagonale Satin-Stich-Linien NUR innerhalb der Buchstabenform
    ofx.globalCompositeOperation = 'source-atop';
    const tw = ofx.measureText(text).width;
    const spacing = Math.max(2.2, fontSize * 0.052);
    const lineColor = lightenColor(color, 0.38);

    ofx.strokeStyle = lineColor;
    ofx.lineWidth   = spacing * 0.65;
    ofx.globalAlpha = 0.52;

    for (let lx = x - tw - fontSize; lx < x + tw + fontSize; lx += spacing) {
      ofx.beginPath();
      ofx.moveTo(lx,               y - fontSize * 1.1);
      ofx.lineTo(lx + fontSize * 1.6, y + fontSize * 1.1);
      ofx.stroke();
    }

    // Feinere Gegen-Linien für Tiefe
    ofx.strokeStyle = darkenColor(color, 0.18);
    ofx.lineWidth   = spacing * 0.3;
    ofx.globalAlpha = 0.22;
    for (let lx = x - tw - fontSize; lx < x + tw + fontSize; lx += spacing * 2.5) {
      ofx.beginPath();
      ofx.moveTo(lx + fontSize * 1.6, y - fontSize * 1.1);
      ofx.lineTo(lx,                  y + fontSize * 1.1);
      ofx.stroke();
    }

    ofx.globalAlpha = 1;
    ofx.globalCompositeOperation = 'source-over';

    // Schmaler dunkler Rand (Fadenkante)
    ofx.globalCompositeOperation = 'destination-over';
    ofx.strokeStyle = darkenColor(color, 0.42);
    ofx.lineWidth   = fontSize * 0.055;
    ofx.lineJoin    = 'round';
    ofx.lineCap     = 'round';
    ofx.strokeText(text, x, y);

    // ── 3. Satin-Schicht auf Haupt-Canvas ────────────────────────────
    ctx.drawImage(ofc, 0, 0);
  }

  function darkenColor(hex, amount) {
    const r = parseInt(hex.slice(1,3), 16);
    const g = parseInt(hex.slice(3,5), 16);
    const b = parseInt(hex.slice(5,7), 16);
    return `rgb(${Math.max(0,Math.floor(r*(1-amount)))},${Math.max(0,Math.floor(g*(1-amount)))},${Math.max(0,Math.floor(b*(1-amount)))})`;
  }

  function lightenColor(hex, amount) {
    const r = parseInt(hex.slice(1,3), 16);
    const g = parseInt(hex.slice(3,5), 16);
    const b = parseInt(hex.slice(5,7), 16);
    return `rgb(${Math.min(255,Math.floor(r+(255-r)*amount))},${Math.min(255,Math.floor(g+(255-g)*amount))},${Math.min(255,Math.floor(b+(255-b)*amount))})`;
  }

  // ── Preis Berechnung ──────────────────────────────────────
  function calcPrice() {
    let total = PRICES.base;
    const rows = [{ label: 'Gebetsteppich', price: PRICES.base }];

    if (state.name1) {
      total += PRICES.name1;
      rows.push({ label: '1. Name besticken', price: PRICES.name1 });
    }
    if (hasSecondName()) {
      total += PRICES.name2;
      rows.push({ label: '2. Name besticken', price: PRICES.name2 });
    }
    if (state.symbol) {
      total += PRICES.symbol;
      rows.push({ label: 'Symbol', price: PRICES.symbol });
    }
    if (state.tasbih) {
      total += PRICES.tasbih;
      rows.push({ label: 'Tasbih', price: PRICES.tasbih });
    }
    if (state.spray) {
      total += PRICES.spray;
      rows.push({ label: 'Lattafa Raumduft', price: PRICES.spray });
    }
    if (state.geschenkverp) {
      total += PRICES.geschenkverp;
      rows.push({ label: 'Geschenkverpackung', price: PRICES.geschenkverp });
    }

    total = Math.round(total * 100) / 100;
    // Geschenkset-Angebot (nur Deutschland, 28.10.2026): mit Geschenkverpackung zahlt der Kunde nie mehr als 49,90 € inkl. Versand.
    // Greift nur, wenn Einzelpreise + Versand (falls unter der Gratis-Grenze) darüber lägen – sonst normale Preise + Versand.
    // 01.11.2026 (User): Warenwert über 49,90 → Set-Rabatt auf 49,90; Warenwert darunter → nur Versand gratis (kein Aufpreis mehr).
    const regularTotal = total;
    const ship = shipInfo();
    const regularPay = (ship && regularTotal < ship.thr) ? regularTotal + ship.fee : regularTotal;
    const set = isDE() && state.geschenkverp && Math.round(regularPay * 100) > Math.round(SET_PRICE * 100);
    if (set) total = Math.min(regularTotal, SET_PRICE);
    const shipSaving = (ship && (total >= ship.thr || set)) ? ship.fee : 0;
    // Vergleichs-Basis = was der Kunde fuer dieselben Teile einzeln WIRKLICH zahlen wuerde (23.10.2026):
    // Versand nur dazu, wenn die Einzelsumme unter der Gratisversand-Grenze laege (in DE ab 49,90 EUR gratis -> beim Set nie).
    const baseShip = (set && ship && regularTotal < ship.thr) ? ship.fee : 0;
    const baseline = set ? Math.round((regularTotal + baseShip) * 100) / 100 : regularTotal;
    const saving = set ? Math.round((baseline - total) * 100) / 100 : 0;
    return { total, rows, regularTotal, set, saving, ship, shipSaving, baseline, baseShip };
  }

  function updatePriceDisplay() {
    const summary = document.getElementById('jk-price-summary');
    if (!summary) return;
    const { total, rows, regularTotal, set, saving, ship, shipSaving, baseline, baseShip } = calcPrice();

    let html = rows.map(r =>
      `<div class="jk-price-row"><span>${r.label}</span><span>${fmt(r.price)}</span></div>`
    ).join('');

    if (set) {
      const pct = Math.round(saving / baseline * 100);
      const versandZeile = baseShip ? `<div class="jk-price-row jk-price-regular jk-price-shipline"><span>+ Versand (${ship.country})</span><span>${fmt(baseShip)}</span></div>` : '';
      html += (baseShip ? `<div class="jk-price-row jk-price-regular"><span>Einzelpreise zusammen</span><span>${fmt(regularTotal)}</span></div>` + versandZeile : '') +
        `<div class="jk-price-row jk-price-regular jk-price-baseline"><span>${baseShip ? 'Einzelpreise + Versand' : 'Einzelpreise zusammen'}</span><span><s>${fmt(baseline)}</s></span></div>` +
        `<div class="jk-set-saving"><span>🎁 Geschenkset-Angebot</span><span>Du sparst ${fmt(saving)} (${pct} %)</span></div>` +
        `<div class="jk-price-total jk-price-total-set"><span>Angebotspreis</span><span>${fmt(total)}</span></div>` +
        `<div class="jk-set-note">✓ inkl. kostenlosem Versand · Set-Preis statt Einzelpreise</div>`;
    } else {
      html += `<div class="jk-price-total"><span>Gesamt</span><span>${fmt(total)}</span></div>`;
      if (shipSaving > 0) {
        html += `<div class="jk-ship-saving"><span>🚚 Kostenloser Versand (${ship.country})</span><span><s>${fmt(shipSaving)}</s> geschenkt</span></div>`;
      }
      if (isDE()) {
        const fehlt = [];
        if (!(state.name1 && state.name1.trim())) fehlt.push('Name');
        if (!state.tasbih) fehlt.push('Tasbih');
        if (!state.spray) fehlt.push('Spray');
        if (!state.geschenkverp) fehlt.push('Geschenkverpackung');
        html += `<div class="jk-set-hint"><strong>🎁 Geschenkset-Angebot: nur 49,90 €</strong> inkl. Teppich und kostenlosem Versand.<br>` +
          `Noch dabei: <em>${fehlt.join(' · ')}</em></div>`;
      } else if (ship && shipSaving === 0) {
        const rest = Math.round((ship.thr - total) * 100) / 100;
        html += `<div class="jk-ship-hint">🚚 Noch ${fmt(rest)} bis zum kostenlosen Versand (${ship.country}, ab ${fmt(ship.thr)})</div>`;
      }
    }
    summary.innerHTML = html;
    updateOfferBar(set, baseline, regularTotal);
    updateBuyBar(total, set, baseline);
  }

  // Angebotsleiste ganz oben (nur Deutschland): in jedem Schritt sichtbar, auch am Handy
  function updateOfferBar(set, baseline, regularTotal) {
    if (!isDE()) return;
    const panel = document.getElementById('jk-config-panel');
    if (!panel) return;
    let bar = document.getElementById('jk-offer-bar');
    if (!bar) {
      bar = document.createElement('div');
      bar.id = 'jk-offer-bar';
      panel.insertBefore(bar, document.getElementById('jk-progress'));
    }
    if (set) {
      bar.className = 'jk-offer-bar jk-offer-on';
      const preis = Math.min(regularTotal, SET_PRICE);
      bar.innerHTML = `<strong>🎁 Geschenkset-Angebot: ${fmt(preis)}</strong><span>einzeln <s>${fmt(baseline)}</s> · du sparst ${fmt(Math.round((baseline - preis) * 100) / 100)}</span>`;
    } else {
      const fehlt = [];
      if (!(state.name1 && state.name1.trim())) fehlt.push('Name');
      if (!state.tasbih) fehlt.push('Tasbih');
      if (!state.spray) fehlt.push('Spray');
      if (!state.geschenkverp) fehlt.push('Verpackung');
      bar.className = 'jk-offer-bar';
      bar.innerHTML = `<strong>🎁 Geschenkset nur ${fmt(SET_PRICE)}</strong><span>inkl. Teppich &amp; kostenlosem Versand · noch: ${fehlt.join(' · ')}</span>`;
    }
  }

  // ── Onepage: Abschnitts-Status (18.10.2026) ───────────────
  // Alle Schritte stehen untereinander auf einer Seite (kein "Weiter" mehr). Jeder Abschnittskopf
  // zeigt die aktuelle Wahl und bekommt ein ✓, sobald etwas gewählt ist.
  function sectionChoice(key) {
    const lbl = (list, k) => (list.find(x => x.key === k) || {}).label || '';
    const SYM = { halbmond: 'Halbmond', herz: 'Herz', unendlich: 'Unendlich' };
    const n1 = (state.name1 || '').trim();
    switch (key) {
      case 'garnfarbe':    return { text: lbl(YARN, state.yarn), done: true };
      case 'schriftart':   return { text: state.font === 'arabic' ? 'Arabisch' : 'Lateinisch', done: true };
      case 'name1':        return { text: n1 ? (hasSecondName() ? n1 + ' ∞ ' + state.name2.trim() : n1) : '', done: !!n1 };
      case 'symbol':       return { text: SYM[state.symbol] || '', done: !!state.symbol };
      case 'tasbih':       return { text: lbl(TASBIH, state.tasbih), done: !!state.tasbih };
      case 'spray':        return { text: lbl(SPRAYS, state.spray), done: !!state.spray };
      case 'geschenkverp': return { text: state.geschenkverp ? 'Ja' : '', done: state.geschenkverp };
    }
    return { text: '', done: false };
  }

  function updateSections() {
    document.querySelectorAll('.jk-sec[data-sec]').forEach(sec => {
      const c = sectionChoice(sec.dataset.sec);
      sec.classList.toggle('jk-done', c.done);
      const ch = sec.querySelector('.jk-sec-choice');
      if (ch) ch.textContent = c.text;
    });
  }

  // Abschnittsköpfe, Preis und Vorschau gemeinsam aktualisieren
  function refresh() {
    updateSections();
    updatePriceDisplay();
    renderCanvas();
  }

  // ── Step Builder ──────────────────────────────────────────
  function buildSteps() {
    const panel = document.getElementById('jk-steps-container');
    if (!panel) return;

    // Preiszeilen liegen nach dem ersten Öffnen im Abschnitt "Deine Auswahl" — vor dem Neuaufbau retten
    const oldSummary = document.getElementById('jk-price-summary');
    if (oldSummary && panel.contains(oldSummary)) panel.parentNode.appendChild(oldSummary);
    panel.innerHTML = '';
    const typbThumb = (CDN_URLS[`typb-${state.color}.jpeg`] || '') + '&width=240';

    // 1 — Stickfarbe
    panel.appendChild(buildStep(1, 'garnfarbe', 'Stickfarbe', 'Kostenlos', `
      <div class="jk-yarn-swatches">
        ${YARN.map(y => `
          <div class="jk-yarn-swatch ${state.yarn === y.key ? 'selected' : ''}" data-yarn="${y.key}">
            <div class="jk-yarn-swatch-circle" style="background:${y.hex};${y.key === 'weiss' ? 'border:1px solid #ccc;' : ''}"></div>
            <span class="jk-yarn-swatch-name">${y.label}</span>
          </div>
        `).join('')}
      </div>
    `));

    // 2 — Schriftart
    panel.appendChild(buildStep(2, 'schriftart', 'Schriftart', 'Kostenlos', `
      <div class="jk-font-options">
        <div class="jk-font-option ${state.font === 'latin' ? 'selected' : ''}" data-font="latin">
          <div class="preview-latin" style="font-family:'AlexBrush',cursive;">Sara</div>
          <div class="label">Lateinisch</div>
        </div>
        <div class="jk-font-option ${state.font === 'arabic' ? 'selected' : ''}" data-font="arabic">
          <div class="preview-arabic" style="font-family:'ReemKufi',sans-serif;">سارة</div>
          <div class="label">Arabisch</div>
        </div>
      </div>
    `));

    // 3 — Name(n)
    panel.appendChild(buildStep(3, 'name1', 'Dein Name', '+9,99 €', `
      <input class="jk-text-input ${state.font === 'arabic' ? 'rtl' : ''}"
             id="jk-name1-input"
             type="text"
             maxlength="20"
             autocomplete="off"
             enterkeyhint="done"
             placeholder="${state.font === 'arabic' ? 'اكتب الاسم هنا' : 'Name eingeben...'}"
             value="${escHtml(state.name1)}" />
      <div class="jk-input-hint">Aufpreis nur, wenn ein Name eingegeben ist</div>
      ${state.font === 'arabic' ? buildArabicKeyboard('jk-kb-1') : ''}
      <!-- 01.11.2026: „Zweiten Namen hinzufügen“ entfernt (User: bestellt keiner, macht es nur komplizierter).
           Rest der 2.-Name-Logik bleibt, greift aber nicht mehr (name2enabled bleibt false). Alter Stand: _BACKUP_OHNE_NAME2_2026-11-01 -->
    `));

    // 4 — Symbol
    panel.appendChild(buildStep(4, 'symbol', 'Symbol', '+3,99 €', `
      <div class="jk-symbol-grid">
        <div class="jk-symbol-card ${state.symbol === 'halbmond' ? 'selected' : ''}" data-symbol="halbmond">
          <div class="jk-symbol-icon">
            <svg viewBox="0 0 60 60" fill="currentColor">
              <path d="M30 8 A22 22 0 1 0 30 52 A14 14 0 1 1 30 8Z"/>
            </svg>
          </div>
          <div class="card-name">Halbmond</div>
        </div>
        <div class="jk-symbol-card ${state.symbol === 'herz' ? 'selected' : ''}" data-symbol="herz">
          <div class="jk-symbol-icon">
            <svg viewBox="0 0 60 60" fill="currentColor">
              <path d="M30 48 C10 36 6 20 14 14 C19 10 25 12 30 18 C35 12 41 10 46 14 C54 20 50 36 30 48Z"/>
            </svg>
          </div>
          <div class="card-name">Herz</div>
        </div>
        <div class="jk-symbol-card ${state.symbol === 'unendlich' ? 'selected' : ''}" data-symbol="unendlich">
          <div class="jk-symbol-icon">
            <svg viewBox="0 0 60 60" fill="none" stroke="currentColor" stroke-width="6" stroke-linecap="round">
              <path d="M10 30 C10 20 20 20 30 30 C40 40 50 40 50 30 C50 20 40 20 30 30 C20 40 10 40 10 30Z"/>
            </svg>
          </div>
          <div class="card-name">Unendlich</div>
        </div>
      </div>
    `, true));

    // 5 — Tasbih
    panel.appendChild(buildStep(5, 'tasbih', 'Tasbih dazu', '+6,99 €', `
      <div class="jk-option-grid jk-grid-tasbih">
        ${TASBIH.map(t => `
          <div class="jk-option-card ${state.tasbih === t.key ? 'selected' : ''}" data-tasbih="${t.key}">
            <img src="${t.img}" alt="${t.label}" loading="lazy" />
            <div class="card-name">${t.label}</div>
          </div>
        `).join('')}
      </div>
    `, true));

    // 6 — Spray
    panel.appendChild(buildStep(6, 'spray', 'Lattafa Raumduft', '+7,99 €', `
      <div class="jk-option-grid jk-grid-spray">
        ${SPRAYS.map(s => `
          <div class="jk-option-card ${state.spray === s.key ? 'selected' : ''}" data-spray="${s.key}">
            <img src="${s.img.replace('width=768', 'width=320')}" alt="${s.label}" loading="lazy" />
            <div class="card-name">${s.label}</div>
          </div>
        `).join('')}
      </div>
    `, true));

    // 7 — Geschenkverpackung (mit Mini-Bild des Geschenkpakets)
    panel.appendChild(buildStep(7, 'geschenkverp', 'Geschenkverpackung', '+3,99 €', `
      <div class="jk-toggle-wrap jk-gift-card ${state.geschenkverp ? 'selected' : ''}" id="jk-gift-toggle" role="button" tabindex="0">
        <span class="jk-gift-ribbon">🎁 Perfekt zum Verschenken</span>
        <img class="jk-gift-thumb" src="${typbThumb}" alt="Geschenkpaket" loading="lazy" />
        <div class="jk-toggle-info">
          <h4>Als Geschenk verpacken</h4>
          <p>Schleife, Jannaty-Anhänger und edles Packaging. Die Vorschau zeigt dir dein Geschenkpaket.</p>
          ${isDE() ? `<p class="jk-gift-set">Mit Name, Tasbih &amp; Spray: Komplett-Set nur ${fmt(SET_PRICE).replace(' ', ' ')} inkl.&nbsp;Versand</p>` : ''}
          <span class="jk-gift-state">${state.geschenkverp ? '✓ Wird als Geschenk verpackt' : 'Antippen zum Einpacken'}</span>
        </div>
        <div class="jk-toggle-switch"></div>
      </div>
    `));
    panel.lastElementChild.classList.add('jk-sec-gift');

    // Deine Auswahl (Warenkorb-Übersicht) — die Preiszeilen werden hierher verschoben
    const sum = document.createElement('div');
    sum.className = 'jk-sec jk-sec-summary';
    sum.innerHTML = `<div class="jk-sec-head"><span class="jk-sec-num">✓</span><span class="jk-sec-title">Deine Auswahl</span></div>`;
    const priceSummary = document.getElementById('jk-price-summary');
    if (priceSummary) sum.appendChild(priceSummary);
    panel.appendChild(sum);

    attachStepListeners();
    updateSections();
  }

  function buildStep(num, key, title, priceText, content, optional = false) {
    const div = document.createElement('div');
    div.className = 'jk-step jk-sec';
    div.dataset.sec = key;
    div.innerHTML = `
      <div class="jk-sec-head">
        <span class="jk-sec-num">${num}</span>
        <span class="jk-sec-title">${title}</span>
        <span class="jk-sec-price">${priceText}${optional ? ' · optional' : ''}</span>
        <span class="jk-sec-choice"></span>
      </div>
      ${content}
    `;
    return div;
  }

  function attachStepListeners() {
    // Symbol
    document.querySelectorAll('[data-symbol]').forEach(el => {
      el.addEventListener('click', () => {
        const key = el.dataset.symbol;
        state.symbol = state.symbol === key ? null : key;
        document.querySelectorAll('[data-symbol]').forEach(e => e.classList.remove('selected'));
        if (state.symbol) el.classList.add('selected');
        refresh();
      });
    });

    // Stickfarbe
    document.querySelectorAll('[data-yarn]').forEach(el => {
      el.addEventListener('click', () => {
        state.yarn = el.dataset.yarn;
        document.querySelectorAll('[data-yarn]').forEach(e => e.classList.remove('selected'));
        el.classList.add('selected');
        refresh();
      });
    });

    // Font
    document.querySelectorAll('[data-font]').forEach(el => {
      el.addEventListener('click', () => {
        state.font = el.dataset.font;
        document.querySelectorAll('[data-font]').forEach(e => e.classList.remove('selected'));
        el.classList.add('selected');
        // RTL für Inputs
        document.querySelectorAll('.jk-text-input').forEach(inp => {
          inp.classList.toggle('rtl', state.font === 'arabic');
          inp.placeholder = state.font === 'arabic' ? 'اكتب الاسم هنا' : 'Name eingeben...';
        });
        // Tastatur dynamisch ein-/ausblenden
        if (state.font === 'arabic') {
          const n1 = document.getElementById('jk-name1-input');
          if (n1 && !document.getElementById('jk-kb-1')) {
            n1.insertAdjacentHTML('afterend', buildArabicKeyboard('jk-kb-1'));
            attachArabicKeyboard(n1, 'jk-kb-1');
          }
          const n2 = document.getElementById('jk-name2-input');
          if (n2 && !document.getElementById('jk-kb-2')) {
            n2.insertAdjacentHTML('afterend', buildArabicKeyboard('jk-kb-2'));
            attachArabicKeyboard(n2, 'jk-kb-2');
          }
        } else {
          ['jk-kb-1','jk-kb-2'].forEach(id => {
            const kb = document.getElementById(id);
            if (kb) kb.remove();
            const knopf = document.querySelector(`[data-kbw="${id}"]`);
            if (knopf) knopf.remove();
          });
          document.querySelectorAll('.jk-text-input').forEach(inp => inp.removeAttribute('inputmode'));   // Latein: normale Handy-Tastatur
        }
        refresh();
      });
    });

    // Name 1
    const name1Input = document.getElementById('jk-name1-input');
    if (name1Input) {
      name1Input.addEventListener('input', () => {
        state.name1 = name1Input.value;
        refresh();
      });
      if (state.font === 'arabic') attachArabicKeyboard(name1Input, 'jk-kb-1');
    }

    // Enter schließt die Handy-Tastatur (das Formular darf nie abgeschickt werden)
    document.querySelectorAll('.jk-text-input').forEach(inp => {
      inp.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); inp.blur(); } });
    });

    // Zweiter Name
    const name2Toggle = document.getElementById('jk-name2-toggle');
    const name2Field  = document.getElementById('jk-name2-field');
    const name2Input  = document.getElementById('jk-name2-input');
    if (name2Toggle && name2Field) {
      const flip = () => {
        state.name2enabled = !state.name2enabled;
        name2Toggle.classList.toggle('selected', state.name2enabled);
        name2Field.style.display = state.name2enabled ? 'block' : 'none';
        if (state.name2enabled && name2Input) name2Input.focus();
        refresh();
      };
      name2Toggle.addEventListener('click', flip);
      name2Toggle.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); flip(); } });
    }
    if (name2Input) {
      name2Input.addEventListener('input', () => {
        state.name2 = name2Input.value;
        refresh();
      });
      if (state.font === 'arabic') attachArabicKeyboard(name2Input, 'jk-kb-2');
    }

    // Tasbih
    document.querySelectorAll('[data-tasbih]').forEach(el => {
      el.addEventListener('click', () => {
        const key = el.dataset.tasbih;
        state.tasbih = state.tasbih === key ? null : key;
        document.querySelectorAll('[data-tasbih]').forEach(e => e.classList.remove('selected'));
        if (state.tasbih) el.classList.add('selected');
        refresh();
      });
    });

    // Spray
    document.querySelectorAll('[data-spray]').forEach(el => {
      el.addEventListener('click', () => {
        const key = el.dataset.spray;
        state.spray = state.spray === key ? null : key;
        document.querySelectorAll('[data-spray]').forEach(e => e.classList.remove('selected'));
        if (state.spray) el.classList.add('selected');
        refresh();
      });
    });

    // Geschenkverpackung — Herzschlag, solange sie nicht gewählt ist
    const giftToggle = document.getElementById('jk-gift-toggle');
    if (giftToggle) {
      giftToggle.style.animation = state.geschenkverp ? 'none' : 'jn-heartbeat 2.8s ease-in-out infinite';
      const flipGift = () => {
        state.geschenkverp = !state.geschenkverp;
        giftToggle.style.animation = state.geschenkverp ? 'none' : 'jn-heartbeat 2.8s ease-in-out infinite';
        giftToggle.classList.toggle('selected', state.geschenkverp);
        const gs = giftToggle.querySelector('.jk-gift-state');
        if (gs) gs.textContent = state.geschenkverp ? '✓ Wird als Geschenk verpackt' : 'Antippen zum Einpacken';
        refresh();
        flashPreview();
      };
      giftToggle.addEventListener('click', flipGift);
      giftToggle.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); flipGift(); } });
    }
  }

  // Kurzer Lichtblick auf der Vorschau, damit der Wechsel zum Geschenkpaket auffällt
  function flashPreview() {
    const w = document.getElementById('jk-canvas-wrap');
    if (!w) return;
    w.classList.remove('jk-flash'); void w.offsetWidth; w.classList.add('jk-flash');
  }

  // ── Bestell-Leiste (immer sichtbar) ───────────────────────
  function buildBuyBar() {
    const panel = document.getElementById('jk-config-panel');
    if (!panel || document.getElementById('jk-buybar')) return;
    const bar = document.createElement('div');
    bar.id = 'jk-buybar';
    bar.innerHTML = `<div class="jk-buybar-price"><span class="jk-buybar-label">Gesamt</span><span class="jk-buybar-total"></span></div>`;
    const orderBtn = document.getElementById('jk-order-btn');
    if (orderBtn) {
      orderBtn.innerHTML = ersetzeKonfig ? (document.documentElement.lang === 'ar' ? 'حفظ التعديلات ←' : 'Änderungen übernehmen →') : 'Jetzt bestellen →';
      orderBtn.classList.add('visible');
      bar.appendChild(orderBtn);
      orderBtn.addEventListener('click', addToCartAndCheckout);
    }
    panel.appendChild(bar);
  }

  function updateBuyBar(total, set, baseline) {
    const t = document.querySelector('#jk-buybar .jk-buybar-total');
    const l = document.querySelector('#jk-buybar .jk-buybar-label');
    if (!t || !l) return;
    l.textContent = set ? '🎁 Geschenkset' : 'Gesamt';
    t.innerHTML = set ? `<s>${fmt(baseline)}</s> ${fmt(total)}` : fmt(total);
    document.getElementById('jk-buybar').classList.toggle('jk-buybar-set', !!set);
  }

  // ── Handy: Vorschau oben, schrumpft beim Scrollen und bleibt stehen ──
  // Größe 1 (full) und Größe 2 (compact) hängen NUR an der vollen Bildschirmhöhe ohne Tastatur (basisH).
  // Früher wurden sie aus der gerade sichtbaren Höhe berechnet: mit offener Tastatur wurde die Vorschau winzig
  // und blieb nach dem Schließen auf einer kleineren "Größe 3" stehen. Bei offener Tastatur gibt es eine eigene Tipp-Größe.
  const mobileMQ = window.matchMedia('(max-width: 768px)');
  let previewSizes = null;
  let basisH = 0, basisW = 0;
  const sichtH = () => (window.visualViewport && window.visualViewport.height) || window.innerHeight;
  const tastaturOffen = () => basisH > 0 && sichtH() < basisH * 0.75;
  function measurePreview() {
    const vw = window.innerWidth;
    if (vw !== basisW) { basisW = vw; basisH = 0; } // Handy gedreht: Grundhöhe neu bestimmen
    if (!tastaturOffen()) basisH = Math.max(basisH, sichtH());
    const full = Math.min(Math.round((vw - 24) * 4 / 3) + 16, Math.round(basisH * 0.62));
    const compact = Math.min(full, Math.round(basisH * 0.40));
    previewSizes = { full, compact };
    const pop = document.getElementById('jk-popup');
    if (pop) pop.style.setProperty('--jk-full', full + 'px');
  }
  // Beim Tippen: gut die Hälfte des sichtbaren Bereichs, damit man den Namen auf dem Teppich entstehen sieht
  const tippHoehe = () => Math.max(180, Math.min(previewSizes.compact, Math.round(sichtH() * 0.55)));
  function onPreviewScroll() {
    const panel = document.getElementById('jk-preview-panel');
    const ov = document.getElementById('jk-overlay');
    if (!panel || !ov) return;
    if (!mobileMQ.matches) { panel.style.removeProperty('--jk-ph'); panel.style.top = ''; panel.classList.remove('jk-compact'); return; }
    if (!previewSizes) measurePreview();
    const tipp = tastaturOffen();
    const h = tipp ? tippHoehe() : Math.max(previewSizes.compact, previewSizes.full - ov.scrollTop);
    panel.style.setProperty('--jk-ph', h + 'px');
    // iPhone verschiebt bei offener Tastatur den sichtbaren Ausschnitt: Vorschau oben im sichtbaren Bereich halten
    const off = tipp && window.visualViewport ? Math.round(window.visualViewport.offsetTop) : 0;
    panel.style.top = off ? off + 'px' : '';
    panel.classList.toggle('jk-compact', tipp || h <= previewSizes.compact + 1);
  }
  // Beim Tippen das Namensfeld direkt unter die Vorschau holen (sonst liegt es hinter Vorschau oder Tastatur)
  function feldZeigen() {
    const el = document.activeElement;
    if (!el || !el.classList || !el.classList.contains('jk-text-input') || !tastaturOffen() || !previewSizes) return;
    const ov = document.getElementById('jk-overlay');
    const vv = window.visualViewport;
    const oben = (vv ? vv.offsetTop : 0) + tippHoehe() + 12;
    const unten = (vv ? vv.offsetTop + vv.height : window.innerHeight) - 8;
    const r = el.getBoundingClientRect();
    if (r.top < oben || r.bottom > unten) ov.scrollTop += Math.round(r.top - oben);
  }
  // Nach dem Schließen der Tastatur wächst die Vorschau auf Größe 2: zuletzt benutztes Feld darunter sichtbar halten
  let letztesFeld = null, warTastatur = false;
  function feldNachTastatur() {
    const offen = tastaturOffen();
    if (offen) { warTastatur = true; return; }
    if (!warTastatur || !letztesFeld || !previewSizes) return;
    const ov = document.getElementById('jk-overlay');
    const panel = document.getElementById('jk-preview-panel');
    const unterkante = panel.getBoundingClientRect().bottom + 12;
    const r = letztesFeld.getBoundingClientRect();
    if (r.top < unterkante) { ov.scrollTop -= Math.round(unterkante - r.top); onPreviewScroll(); }
    clearTimeout(feldNachTastatur.t); feldNachTastatur.t = setTimeout(() => { warTastatur = false; }, 900);
  }
  let previewBound = false;
  function initMobilePreview() {
    measurePreview();
    onPreviewScroll();
    if (previewBound) return;
    previewBound = true;
    const ov = document.getElementById('jk-overlay');
    let raf = 0;
    const tick = () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; onPreviewScroll(); }); };
    ov.addEventListener('scroll', tick, { passive: true });
    // Zwei-Finger-Zoom ändert die sichtbare Höhe (visualViewport), ist aber kein kleinerer Bildschirm:
    // nur bei Zoom 1 neu messen (z. B. Tastatur auf/zu), sonst springt die Vorschau und der Inhalt verschiebt sich.
    const remeasure = () => {
      if (window.visualViewport && Math.abs(window.visualViewport.scale - 1) > 0.01) return;
      measurePreview(); onPreviewScroll(); feldZeigen(); feldNachTastatur();
    };
    window.addEventListener('resize', remeasure);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', remeasure);
      window.visualViewport.addEventListener('scroll', tick);
    }
    // Tastatur fährt animiert auf/zu: mehrmals nachmessen, bis sie ganz offen bzw. zu ist
    const nachmessen = () => [60, 300, 700].forEach(t => setTimeout(remeasure, t));
    ov.addEventListener('focusin', e => { if (e.target.classList.contains('jk-text-input')) { letztesFeld = e.target; warTastatur = false; nachmessen(); } });
    ov.addEventListener('focusout', e => { if (e.target.classList.contains('jk-text-input')) nachmessen(); });
    // Antippen der Vorschau = Vollbild, nochmal antippen = zurück
    const panel = document.getElementById('jk-preview-panel');
    panel.addEventListener('click', () => {
      if (!mobileMQ.matches) return;
      panel.classList.toggle('jk-zoom');
    });
  }

  // Sprach-Wurzel des Shops ('/' für Deutsch, '/ar/' für Arabisch) – Warenkorb und Kasse bleiben in der gewählten Sprache
  function shopRoot() {
    const r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.endsWith('/') ? r : r + '/';
  }
  // Nur Arabisch: Bestellangaben zweisprachig (Deutsch für die Werkstatt / Arabisch für den Kunden)
  const AR_BEST = {
    '1. Name': 'الاسم الأول', '2. Name': 'الاسم الثاني', 'Zeichen zwischen den Namen': 'الرمز بين الاسمين', 'Unendlich (∞)': 'لانهاية (∞)',
    'Stickfarbe': 'لون التطريز', 'Schriftart': 'نوع الخط', 'Arabisch': 'عربي', 'Lateinisch': 'لاتيني',
    'Symbol': 'الرمز', 'Halbmond': 'هلال', 'Herz': 'قلب', 'Unendlich': 'لانهاية', 'halbmond': 'هلال', 'herz': 'قلب', 'unendlich': 'لانهاية',
    'Tasbih': 'مسبحة', 'Spray': 'معطّر', 'Geschenkverpackung': 'تغليف الهدية', 'Ja': 'نعم', 'Zum Teppich': 'للسجادة',
    'Gold': 'ذهبي', 'Silber': 'فضي', 'Taupe': 'رمادي بني', 'Beige': 'بيج', 'Schwarz': 'أسود', 'Rosa': 'وردي',
    'Weiß': 'أبيض', 'Blau': 'أزرق', 'Babyblau': 'أزرق فاتح', 'Grün': 'أخضر', 'Lila': 'بنفسجي', 'Rot': 'أحمر',
    'Obsidian': 'أسود', 'Mitternacht': 'أزرق ليلي', 'Saphir': 'أزرق ياقوتي', 'Steingrau': 'رمادي', 'Platin': 'بلاتيني',
    'Alabaster': 'أبيض عاجي', 'Smaragd': 'أخضر زمردي', 'Granat': 'أحمر عقيقي', 'Amethyst': 'بنفسجي جمشتي',
    'Kaschmir': 'كشميري', 'Altrosa': 'وردي قديم', 'Rosenquarz': 'وردي كوارتز'
  };

  // ── Add to Cart → Warenkorb ───────────────────────────────
  let orderInProgress = false;
  async function addToCartAndCheckout() {
    if (orderInProgress) return;
    const colorData = COLORS.find(c => c.key === state.color);
    if (!colorData) return;
    orderInProgress = true;

    const label = (list, key) => (list.find(x => x.key === key) || {}).label || key;
    const istAR = document.documentElement.lang === 'ar';
    const ar = (t) => (istAR && AR_BEST[t]) ? t + ' / ' + AR_BEST[t] : t;
    const konfigId = 'K' + Date.now().toString(36);
    const selection = {};
    if (state.name1) selection[ar('1. Name')] = state.name1;
    if (hasSecondName()) { selection[ar('2. Name')] = state.name2; selection[ar('Zeichen zwischen den Namen')] = ar('Unendlich (∞)'); }
    selection[ar('Stickfarbe')] = ar(label(YARN, state.yarn));
    selection[ar('Schriftart')] = ar(state.font === 'arabic' ? 'Arabisch' : 'Lateinisch');
    if (state.symbol) selection[ar('Symbol')] = ar(state.symbol);
    if (state.tasbih) selection[ar('Tasbih')] = ar(label(TASBIH, state.tasbih));
    if (state.spray) selection[ar('Spray')] = label(SPRAYS, state.spray);
    if (state.geschenkverp) selection[ar('Geschenkverpackung')] = ar('Ja');

    // Teppich (mit allen Angaben für die Produktion) + jedes gewählte Extra als eigene Zeile — alles atomar in einem Aufruf
    const items = [{ id: colorData.variantId, quantity: 1, properties: Object.assign({ '_konfig': konfigId }, selection) }];
    let fehlt = false;
    const extra = (teil, id) => { if (id) items.push({ id, quantity: 1, properties: { '_konfig': konfigId, '_jn_teil': teil } }); else fehlt = true; };
    if (state.name1) extra('name', EXTRAS.name);
    if (state.symbol) extra('symbol', EXTRAS.symbol[state.symbol]);
    if (state.tasbih) extra('tasbih', EXTRAS.tasbih[state.tasbih]);
    if (state.spray) extra('spray', EXTRAS.spray[state.spray]);
    if (state.geschenkverp) extra('geschenk', EXTRAS.geschenk);
    if (fehlt) {
      orderInProgress = false;
      console.error('Extra-Artikel fehlt', state);
      alert('Ein Fehler ist aufgetreten. Bitte versuche es erneut.');
      return;
    }
    items.reverse();   // Shopify zeigt die zuletzt hinzugefügte Zeile oben → so steht an der Kasse der Teppich zuerst, dann Name … Verpackung

    try {
      const res = await fetch(shopRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });

      if (!res.ok) throw new Error('Cart error');

      // 01.11.2026 „Personalisierung ändern“: erst nach erfolgreichem Hinzufügen die alte Fassung (Teppich + Extras) entfernen
      if (ersetzeKonfig) {
        const alt = await (await fetch(shopRoot() + 'cart.js')).json();
        const updates = {};
        alt.items.forEach(i => { if (i.properties && i.properties._konfig === ersetzeKonfig) updates[i.key] = 0; });
        if (Object.keys(updates).length) {
          await fetch(shopRoot() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
        }
      }

      // 01.11.2026 (User): erst in den Warenkorb statt direkt zur Kasse – dort sieht der Kunde alles, kann löschen/ändern
      // und „Weiteren Teppich hinzufügen“; alte Teppiche im Warenkorb fallen vor dem Bezahlen auf.
      window.location.href = shopRoot() + 'cart';
    } catch (err) {
      console.error('Fehler beim Warenkorb:', err);
      orderInProgress = false;
      alert('Ein Fehler ist aufgetreten. Bitte versuche es erneut.');
    }
  }

  // ── Personalisierung ändern (01.11.2026, User) ─────────────
  // Warenkorb-Karte verlinkt auf ?variant=<Teppich>&jn_aendern=<_konfig>#jn-farbe: Teppich-Seite mit vorausgewählter Farbe, Sprung
  // zur Farbauswahl (User: „beginnend von der Teppichfarbauswahl“). Alle Angaben sind vorbelegt; „Änderungen übernehmen“ legt die
  // neue Fassung in den Warenkorb und entfernt die alte (siehe addToCartAndCheckout).
  let ersetzeKonfig = null;
  async function aendernAusWarenkorb() {
    const k = new URLSearchParams(location.search).get('jn_aendern');
    if (!k) return;
    try {
      const cart = await (await fetch(shopRoot() + 'cart.js')).json();
      const t = cart.items.find(i => i.properties && i.properties._konfig === k && !i.properties._jn_teil && COLORS.some(c => c.variantId === i.variant_id));
      if (!t) return;
      const p = {};
      Object.keys(t.properties).forEach(n => { p[n.split(' / ')[0]] = String(t.properties[n] || ''); });
      const de = v => (v || '').split(' / ')[0].trim();
      const schluessel = (liste, wert) => (liste.find(x => x.label === de(wert)) || {}).key || null;
      state.yarn = schluessel(YARN, p['Stickfarbe']) || state.yarn;
      state.font = de(p['Schriftart']) === 'Arabisch' ? 'arabic' : 'latin';
      state.name1 = p['1. Name'] || '';
      state.symbol = de(p['Symbol']).toLowerCase() || null;
      state.tasbih = schluessel(TASBIH, p['Tasbih']);
      state.spray = schluessel(SPRAYS, p['Spray']);
      state.geschenkverp = !!p['Geschenkverpackung'];
      state.color = COLORS.find(c => c.variantId === t.variant_id).key;
      ersetzeKonfig = k;
      // Hinweis über „Jetzt personalisieren“: der Kunde bearbeitet seinen Teppich, kein neuer kommt dazu
      const istAR = document.documentElement.lang === 'ar';
      const name = state.name1 ? (istAR ? ` «${state.name1}»` : ` „${state.name1}“`) : '';
      document.querySelectorAll('.jannaty-personalize-btn').forEach(b => {
        if (!b.offsetParent || b.previousElementSibling?.classList.contains('jn-aendern-hinweis')) return;
        const h = document.createElement('div');
        h.className = 'jn-aendern-hinweis';
        h.setAttribute('dir', istAR ? 'rtl' : 'ltr');
        h.innerHTML = istAR
          ? `<strong>✎ أنت تعدّل سجادتك${name}</strong><span>اختر اللون إن أردت ثم اضغط «خصّص الآن» – كل اختياراتك محفوظة.</span>`
          : `<strong>✎ Du änderst deinen Teppich${name}</strong><span>Farbe ggf. neu wählen, dann „Jetzt personalisieren“ – alle Angaben sind schon ausgefüllt.</span>`;
        h.style.cssText = 'margin:0 0 12px;padding:12px 14px;border-radius:14px;border:1.5px dashed #cdb48a;background:#fbf6ee;color:#3b3226;display:flex;flex-direction:column;gap:4px;font-size:14px;line-height:1.4;';
        b.parentNode.insertBefore(h, b);
      });
    } catch (e) { console.error('Personalisierung ändern:', e); }
  }

  // ── Open / Close ──────────────────────────────────────────
  function openKonfigurator(selectedColorKey) {
    if (selectedColorKey) state.color = selectedColorKey;
    state.currentStep = 0;

    overlay = document.getElementById('jk-overlay');
    if (!overlay) return;

    overlay.classList.add('jk-open');
    document.body.style.overflow = 'hidden';

    // Header unter den Overlay schieben
    document.querySelectorAll('#header-group, #header-component, header, .header, [id*="header"], [class*="header"]').forEach(el => {
      el.dataset.jkOrigZ = el.style.zIndex || '';
      el.style.zIndex = '0';
    });

    canvas = document.getElementById('jk-canvas');
    previewLabel = document.querySelector('.jk-preview-label');

    if (canvas) {
      ctx = canvas.getContext('2d');
      // Canvas Größe: 2:3 Portrait für Gebetsteppich
      canvas.width = 600;
      canvas.height = 900;
    }

    buildSteps();
    loadFonts().then(() => renderCanvas());
    updatePriceDisplay();
    initPositionMode();

    // Onepage: Bestell-Leiste, Geschenkpaket vorladen, oben beginnen, Handy-Vorschau
    buildBuyBar();
    updatePriceDisplay();
    preloadTypB();
    overlay.scrollTop = 0;
    const pp = document.getElementById('jk-preview-panel');
    if (pp) pp.classList.remove('jk-zoom');
    initMobilePreview();

    // Zurück-Taste (Handy) schließt die Personalisierung statt die Seite zu verlassen
    try {
      if (!(history.state && history.state.jkOpen)) history.pushState({ jkOpen: true }, '');
    } catch (e) {}
  }

  window.addEventListener('popstate', () => {
    const ov = document.getElementById('jk-overlay');
    if (ov && ov.classList.contains('jk-open')) closeKonfigurator(true);
  });

  function closeKonfigurator(fromHistory) {
    const ov = document.getElementById('jk-overlay');
    if (!ov || !ov.classList.contains('jk-open')) return;
    ov.classList.remove('jk-open');
    document.body.style.overflow = '';
    if (fromHistory !== true) {
      try { if (history.state && history.state.jkOpen) history.back(); } catch (e) {}
    }

    // Header z-index wiederherstellen
    document.querySelectorAll('[data-jk-orig-z]').forEach(el => {
      el.style.zIndex = el.dataset.jkOrigZ || '';
      delete el.dataset.jkOrigZ;
    });
  }

  // ── Verfügbarkeit der Teppichfarben ───────────────────────
  // Ausverkaufte Farbe gewählt: Hinweis im Produktbild, Personalisieren-Button gesperrt.
  // Die Sortierung (verfügbare zuerst) läuft per CSS in jannaty-konfigurator.css.
  const variantAvailable = {};
  const SOLDOUT_TEXT = 'Diese Farbe ist derzeit nicht verfügbar';

  function selectedVariantId() {
    const s = document.querySelector('[name="id"]');
    return s ? parseInt(s.value) : null;
  }

  function isSelectedAvailable() {
    const id = selectedVariantId();
    return !(id && variantAvailable[id] === false);
  }

  function updateAvailabilityUI() {
    const ok = isSelectedAvailable();
    document.querySelectorAll('.jannaty-personalize-btn').forEach(btn => {
      if (btn.dataset.jkLabel === undefined) btn.dataset.jkLabel = btn.innerHTML;
      btn.disabled = !ok;
      btn.classList.toggle('jk-btn-unavailable', !ok);
      btn.innerHTML = ok ? btn.dataset.jkLabel : SOLDOUT_TEXT;
    });
    const media = document.querySelector('.product-information__media') || document.querySelector('media-gallery');
    if (!media) return;
    let badge = media.querySelector('.jk-soldout-badge');
    if (!ok && !badge) {
      badge = document.createElement('div');
      badge.className = 'jk-soldout-badge';
      badge.textContent = SOLDOUT_TEXT;
      media.appendChild(badge);
    }
    if (badge) badge.hidden = ok;
    media.classList.toggle('jk-media-soldout', !ok);
  }

  async function initAvailability() {
    try {
      const res = await fetch(location.pathname.replace(/\/$/, '') + '.js');
      const product = await res.json();
      product.variants.forEach(v => { variantAvailable[v.id] = v.available; });
    } catch (e) { return; }
    let lastId = null;
    const check = () => {
      const id = selectedVariantId();
      if (id !== lastId) { lastId = id; updateAvailabilityUI(); }
    };
    check();
    setInterval(check, 400);
  }

  // ── Init ──────────────────────────────────────────────────
  function init() {
    initAvailability();

    // "Personalisieren" Button
    document.querySelectorAll('.jannaty-personalize-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        if (!isSelectedAvailable()) return;
        // Aktive Variante aus der Produktseite lesen
        const variantSelect = document.querySelector('[name="id"]');
        let selectedColor = 'obsidian';
        if (variantSelect) {
          const variantId = parseInt(variantSelect.value);
          const match = COLORS.find(c => c.variantId === variantId);
          if (match) selectedColor = match.key;
        }
        openKonfigurator(selectedColor);
      });
    });

    // Sicherung: solange die Personalisierung offen ist, darf das Produkt-Formular nie abgeschickt werden
    const jkForm = document.getElementById('jk-overlay')?.closest('form');
    if (jkForm) jkForm.addEventListener('submit', (e) => {
      if (document.getElementById('jk-overlay').classList.contains('jk-open')) { e.preventDefault(); e.stopImmediatePropagation(); }
    }, true);

    // Close Button
    const closeBtn = document.getElementById('jk-close');
    if (closeBtn) closeBtn.addEventListener('click', closeKonfigurator);

    // Overlay Click außerhalb
    const ov = document.getElementById('jk-overlay');
    if (ov) {
      ov.addEventListener('click', (e) => {
        if (e.target === ov) closeKonfigurator();
      });
    }

    // ESC Key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeKonfigurator();
    });

    aendernAusWarenkorb();

    // Preload Typ-A Bilder im Hintergrund
    COLORS.forEach(c => {
      loadImage(`${CDN}typa-${c.key}.jpeg`);
    });
  }

  // ── Arabic Virtual Keyboard ───────────────────────────────
  const ARABIC_ROWS = [
    ['ض','ص','ث','ق','ف','غ','ع','ه','خ','ح','ج'],
    ['ش','س','ي','ب','ل','ا','ت','ن','م','ك','ط'],
    ['ئ','ء','ؤ','ر','ى','ة','و','ز','ظ','ذ','د'],
    ['أ','إ','آ','لا','⌫','␣'],
  ];

  // 31.10.2026: Bei arabischer Schrift öffnete das Handy zusätzlich seine eigene Tastatur (bei jedem Tipp auf unsere
  // Tasten erneut, wegen focus()). Jetzt: Namensfeld mit inputmode="none" → nur unsere Tastatur. Wer lieber die
  // Handy-Tastatur nimmt (z. B. eigene arabische), schaltet per Link um; gilt dann für beide Namensfelder.
  let handyTastatur = false;
  const KBW_TEXT = () => document.documentElement.lang === 'ar'
    ? { handy: '⌨ استخدم لوحة مفاتيح الهاتف', eigene: '⌨ إظهار لوحة المفاتيح العربية هنا' }
    : { handy: '⌨ Handy-Tastatur benutzen', eigene: '⌨ Arabische Tastatur hier anzeigen' };

  function tastaturModus() {
    [['jk-name1-input', 'jk-kb-1'], ['jk-name2-input', 'jk-kb-2']].forEach(([inpId, kbId]) => {
      const inp = document.getElementById(inpId), kb = document.getElementById(kbId);
      const knopf = document.querySelector(`[data-kbw="${kbId}"]`);
      if (!inp || !kb) return;
      inp.setAttribute('inputmode', handyTastatur ? 'text' : 'none');
      kb.style.display = handyTastatur ? 'none' : '';
      if (knopf) knopf.textContent = handyTastatur ? KBW_TEXT().eigene : KBW_TEXT().handy;
    });
  }

  function buildArabicKeyboard(id) {
    let html = `<div class="jk-arab-kb" id="${id}" dir="rtl"${handyTastatur ? ' style="display:none"' : ''}>`;
    for (let ri = 0; ri < ARABIC_ROWS.length; ri++) {
      html += '<div class="jk-kb-row">';
      for (const ch of ARABIC_ROWS[ri]) {
        if (ch === '⌫') {
          html += `<button type="button" class="jk-kb-key jk-kb-back" data-kb="${id}" data-char="⌫">⌫</button>`;
        } else if (ch === '␣') {
          html += `<button type="button" class="jk-kb-key jk-kb-space" data-kb="${id}" data-char=" ">مسافة</button>`;
        } else {
          html += `<button type="button" class="jk-kb-key" data-kb="${id}" data-char="${ch}">${ch}</button>`;
        }
      }
      html += '</div>';
    }
    html += '</div>';
    html += `<button type="button" class="jk-kb-wechsel" data-kbw="${id}">${handyTastatur ? KBW_TEXT().eigene : KBW_TEXT().handy}</button>`;
    return html;
  }

  function attachArabicKeyboard(inputEl, kbId) {
    const kb = document.getElementById(kbId);
    if (!kb || !inputEl) return;
    inputEl.setAttribute('inputmode', handyTastatur ? 'text' : 'none');   // keine zweite (Handy-)Tastatur
    const knopf = document.querySelector(`[data-kbw="${kbId}"]`);
    if (knopf) knopf.addEventListener('click', () => {
      handyTastatur = !handyTastatur;
      tastaturModus();
      if (handyTastatur) { inputEl.blur(); inputEl.focus(); }   // im selben Tipp → Handy-Tastatur geht auf
      else inputEl.blur();                                        // Handy-Tastatur zu, unsere ist wieder da
    });
    kb.addEventListener('mousedown', e => e.preventDefault()); // prevent input blur
    kb.addEventListener('click', e => {
      const btn = e.target.closest('[data-char]');
      if (!btn) return;
      const ch = btn.dataset.char;
      inputEl.focus();
      if (ch === '⌫') {
        const s = inputEl.selectionStart, e2 = inputEl.selectionEnd;
        if (s === e2 && s > 0) {
          inputEl.value = inputEl.value.slice(0, s - 1) + inputEl.value.slice(s);
          inputEl.selectionStart = inputEl.selectionEnd = s - 1;
        } else {
          inputEl.value = inputEl.value.slice(0, s) + inputEl.value.slice(e2);
          inputEl.selectionStart = inputEl.selectionEnd = s;
        }
      } else {
        const s = inputEl.selectionStart, e2 = inputEl.selectionEnd;
        inputEl.value = inputEl.value.slice(0, s) + ch + inputEl.value.slice(e2);
        inputEl.selectionStart = inputEl.selectionEnd = s + ch.length;
      }
      inputEl.dispatchEvent(new Event('input'));
    });
  }

  // ── Helpers ───────────────────────────────────────────────
  function escHtml(str) {
    return (str || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  // ── Positions-Modus (?pos=1) ──────────────────────────────
  function initPositionMode() {
    if (!window.location.search.includes('pos=1')) return;
    if (document.getElementById('jk-pos-ui')) return; // bereits gebaut

      const ui = document.createElement('div');
      ui.id = 'jk-pos-ui';
      ui.style.cssText = `
        position:fixed; top:60px; right:10px;
        background:rgba(0,0,0,0.88); color:#fff; padding:14px 20px;
        border-radius:12px; z-index:2147483647; width:280px;
        font-family:system-ui,sans-serif; font-size:13px;
        max-height:85vh; overflow-y:auto;
        cursor:move; user-select:none;
      `;
      // Drag-to-move
      let _dx=0,_dy=0,_dragging=false;
      ui.addEventListener('mousedown', e => { if(e.target.tagName==='INPUT') return; _dragging=true; _dx=e.clientX-ui.getBoundingClientRect().left; _dy=e.clientY-ui.getBoundingClientRect().top; });
      document.addEventListener('mousemove', e => { if(!_dragging) return; ui.style.left=Math.max(0,e.clientX-_dx)+'px'; ui.style.top=Math.max(0,e.clientY-_dy)+'px'; ui.style.right='auto'; });
      document.addEventListener('mouseup', () => _dragging=false);
      ui.innerHTML = `
        <div style="font-weight:700;margin-bottom:8px;color:#C6A84B;cursor:pointer;" onclick="document.getElementById('jk-lat-section').style.display=document.getElementById('jk-lat-section').style.display==='none'?'block':'none'">📍 Lateinisch ▾</div>
        <div id="jk-lat-section" style="display:none">
        <label>Links ↔ Rechts: <strong id="jk-pos-xval">${NAME_POS.x.toFixed(2)}</strong></label>
        <input type="range" id="jk-pos-x" min="0" max="100" value="${NAME_POS.x * 100}" style="width:100%;margin:3px 0 8px;accent-color:#C6A84B;">
        <label>Oben ↕ Unten: <strong id="jk-pos-yval">${NAME_POS.y.toFixed(2)}</strong></label>
        <input type="range" id="jk-pos-y" min="0" max="100" value="${NAME_POS.y * 100}" style="width:100%;margin:3px 0 8px;accent-color:#C6A84B;">
        <label>↺ Kippen: <strong id="jk-pos-rval">${NAME_POS.r}°</strong></label>
        <input type="range" id="jk-pos-r" min="-60" max="60" value="${NAME_POS.r}" style="width:100%;margin:3px 0 8px;accent-color:#C6A84B;">
        <label>🔤 Größe: <strong id="jk-pos-sval">${NAME_POS.size.toFixed(2)}</strong></label>
        <input type="range" id="jk-pos-s" min="20" max="200" value="${NAME_POS.size * 100}" style="width:100%;margin:3px 0 12px;accent-color:#C6A84B;">
        </div>

        <div style="font-weight:700;margin-bottom:8px;color:#7EB8C9;">🔤 Arabisch</div>
        <label>Links ↔ Rechts: <strong id="jk-apos-xval">${ARABIC_POS.x.toFixed(2)}</strong></label>
        <input type="range" id="jk-apos-x" min="0" max="100" value="${ARABIC_POS.x * 100}" style="width:100%;margin:3px 0 8px;accent-color:#7EB8C9;">
        <label>Oben ↕ Unten: <strong id="jk-apos-yval">${ARABIC_POS.y.toFixed(2)}</strong></label>
        <input type="range" id="jk-apos-y" min="0" max="100" value="${ARABIC_POS.y * 100}" style="width:100%;margin:3px 0 8px;accent-color:#7EB8C9;">
        <label>↺ Kippen: <strong id="jk-apos-rval">${ARABIC_POS.r}°</strong></label>
        <input type="range" id="jk-apos-r" min="-60" max="60" value="${ARABIC_POS.r}" style="width:100%;margin:3px 0 8px;accent-color:#7EB8C9;">
        <label>🔤 Größe: <strong id="jk-apos-sval">${ARABIC_POS.size.toFixed(3)}</strong></label>
        <input type="range" id="jk-apos-s" min="2" max="20" value="${ARABIC_POS.size * 100}" style="width:100%;margin:3px 0 8px;accent-color:#7EB8C9;">

        <div style="font-weight:700;margin-bottom:8px;color:#a8c87e;">🌿 Spray</div>
        <label>Links ↔ Rechts: <strong id="jk-spos-xval">${SPRAY_POS.x.toFixed(2)}</strong></label>
        <input type="range" id="jk-spos-x" min="0" max="100" value="${SPRAY_POS.x * 100}" style="width:100%;margin:3px 0 8px;accent-color:#a8c87e;">
        <label>Oben ↕ Unten: <strong id="jk-spos-yval">${SPRAY_POS.y.toFixed(2)}</strong></label>
        <input type="range" id="jk-spos-y" min="0" max="100" value="${SPRAY_POS.y * 100}" style="width:100%;margin:3px 0 8px;accent-color:#a8c87e;">
        <label>📐 Größe: <strong id="jk-spos-sval">${SPRAY_POS.size.toFixed(2)}</strong></label>
        <input type="range" id="jk-spos-s" min="5" max="80" value="${SPRAY_POS.size * 100}" style="width:100%;margin:3px 0 8px;accent-color:#a8c87e;">
        <label>↺ Drehen: <strong id="jk-spos-rval">${SPRAY_POS.r}°</strong></label>
        <input type="range" id="jk-spos-r" min="-180" max="180" value="${SPRAY_POS.r}" style="width:100%;margin:3px 0 12px;accent-color:#a8c87e;">

        <div style="font-weight:700;margin-bottom:8px;color:#c8a46e;">📿 Tasbih</div>
        <label>Links ↔ Rechts: <strong id="jk-tpos-xval">${TASBIH_POS.x.toFixed(2)}</strong></label>
        <input type="range" id="jk-tpos-x" min="0" max="100" value="${TASBIH_POS.x * 100}" style="width:100%;margin:3px 0 8px;accent-color:#c8a46e;">
        <label>Oben ↕ Unten: <strong id="jk-tpos-yval">${TASBIH_POS.y.toFixed(2)}</strong></label>
        <input type="range" id="jk-tpos-y" min="0" max="100" value="${TASBIH_POS.y * 100}" style="width:100%;margin:3px 0 8px;accent-color:#c8a46e;">
        <label>📐 Größe: <strong id="jk-tpos-sval">${TASBIH_POS.size.toFixed(2)}</strong></label>
        <input type="range" id="jk-tpos-s" min="5" max="80" value="${TASBIH_POS.size * 100}" style="width:100%;margin:3px 0 8px;accent-color:#c8a46e;">
        <label>↺ Drehen: <strong id="jk-tpos-rval">${TASBIH_POS.r}°</strong></label>
        <input type="range" id="jk-tpos-r" min="-180" max="180" value="${TASBIH_POS.r}" style="width:100%;margin:3px 0 8px;accent-color:#c8a46e;">

        <div id="jk-pos-result" style="margin-top:6px;font-size:11px;color:#fff;background:#333;padding:6px 8px;border-radius:6px;">
          LAT: x:${NAME_POS.x.toFixed(2)} y:${NAME_POS.y.toFixed(2)} r:${NAME_POS.r}° s:${NAME_POS.size.toFixed(2)}<br>
          ARB: x:${ARABIC_POS.x.toFixed(2)} y:${ARABIC_POS.y.toFixed(2)} r:${ARABIC_POS.r}° s:${ARABIC_POS.size.toFixed(3)}<br>
          SPR: x:${SPRAY_POS.x.toFixed(2)} y:${SPRAY_POS.y.toFixed(2)} s:${SPRAY_POS.size.toFixed(2)} r:${SPRAY_POS.r}°<br>
          TAS: x:${TASBIH_POS.x.toFixed(2)} y:${TASBIH_POS.y.toFixed(2)} s:${TASBIH_POS.size.toFixed(2)} r:${TASBIH_POS.r}°
        </div>
        <div style="margin-top:4px;font-size:11px;color:#888;">Diese Zahlen an Claude schicken ✓</div>

        <div style="font-weight:700;margin:12px 0 8px;color:#e8c06a;cursor:pointer;border-top:1px solid #555;padding-top:10px;" onclick="var s=document.getElementById('jk-b-section');s.style.display=s.style.display==='none'?'block':'none'">🎁 Typ-B Positionen ▾</div>
        <div id="jk-b-section" style="display:none">
        <div style="font-size:11px;color:#aaa;margin-bottom:6px;">Aktiviere Geschenkverpackung damit Änderungen sichtbar werden</div>
        <div style="font-weight:600;margin-bottom:4px;color:#C6A84B;">📍 Schrift Lateinisch (B)</div>
        <label>Links ↔ Rechts: <strong id="jk-bnp-xval">${NAME_POS_B.x.toFixed(2)}</strong></label>
        <input type="range" id="jk-bnp-x" min="0" max="100" value="${NAME_POS_B.x * 100}" style="width:100%;margin:3px 0 8px;accent-color:#C6A84B;">
        <label>Oben ↕ Unten: <strong id="jk-bnp-yval">${NAME_POS_B.y.toFixed(2)}</strong></label>
        <input type="range" id="jk-bnp-y" min="0" max="100" value="${NAME_POS_B.y * 100}" style="width:100%;margin:3px 0 8px;accent-color:#C6A84B;">
        <label>↺ Kippen: <strong id="jk-bnp-rval">${NAME_POS_B.r}°</strong></label>
        <input type="range" id="jk-bnp-r" min="-60" max="60" value="${NAME_POS_B.r}" style="width:100%;margin:3px 0 8px;accent-color:#C6A84B;">
        <label>🔤 Größe: <strong id="jk-bnp-sval">${NAME_POS_B.size.toFixed(2)}</strong></label>
        <input type="range" id="jk-bnp-s" min="20" max="200" value="${NAME_POS_B.size * 100}" style="width:100%;margin:3px 0 8px;accent-color:#C6A84B;">
        <label>⇥ Rechter Rand: <strong id="jk-bnp-xrval">${NAME_POS_B.xRight.toFixed(2)}</strong></label>
        <input type="range" id="jk-bnp-xr" min="0" max="100" value="${NAME_POS_B.xRight * 100}" style="width:100%;margin:3px 0 8px;accent-color:#C6A84B;">
        <label>↤ Linker Rand: <strong id="jk-bnp-xlval">${NAME_POS_B.xLeft.toFixed(2)}</strong></label>
        <input type="range" id="jk-bnp-xl" min="0" max="100" value="${NAME_POS_B.xLeft * 100}" style="width:100%;margin:3px 0 10px;accent-color:#C6A84B;">

        <div style="font-weight:600;margin-bottom:4px;color:#e88a8a;">🎀 Schleife (Maske)</div>
        <div style="font-size:11px;color:#aaa;margin-bottom:4px;">Schleifenbereich kalibrieren — Text verschwindet hier</div>
        <label>Links ↔ Rechts: <strong id="jk-bow-xval">${BOW_POS.x.toFixed(2)}</strong></label>
        <input type="range" id="jk-bow-x" min="0" max="100" value="${BOW_POS.x * 100}" style="width:100%;margin:3px 0 8px;accent-color:#e88a8a;">
        <label>Oben ↕ Unten: <strong id="jk-bow-yval">${BOW_POS.y.toFixed(2)}</strong></label>
        <input type="range" id="jk-bow-y" min="0" max="100" value="${BOW_POS.y * 100}" style="width:100%;margin:3px 0 8px;accent-color:#e88a8a;">
        <label>↔ Breite: <strong id="jk-bow-wval">${BOW_POS.w.toFixed(2)}</strong></label>
        <input type="range" id="jk-bow-w" min="0" max="100" value="${BOW_POS.w * 100}" style="width:100%;margin:3px 0 8px;accent-color:#e88a8a;">
        <label>↕ Höhe: <strong id="jk-bow-hval">${BOW_POS.h.toFixed(2)}</strong></label>
        <input type="range" id="jk-bow-h" min="0" max="100" value="${BOW_POS.h * 100}" style="width:100%;margin:3px 0 10px;accent-color:#e88a8a;">

        <div style="font-weight:600;margin-bottom:4px;color:#a8c87e;">🌿 Spray (B)</div>
        <label>Links ↔ Rechts: <strong id="jk-bsp-xval">${SPRAY_POS_B.x.toFixed(2)}</strong></label>
        <input type="range" id="jk-bsp-x" min="0" max="100" value="${SPRAY_POS_B.x * 100}" style="width:100%;margin:3px 0 8px;accent-color:#a8c87e;">
        <label>Oben ↕ Unten: <strong id="jk-bsp-yval">${SPRAY_POS_B.y.toFixed(2)}</strong></label>
        <input type="range" id="jk-bsp-y" min="0" max="100" value="${SPRAY_POS_B.y * 100}" style="width:100%;margin:3px 0 8px;accent-color:#a8c87e;">
        <label>📐 Größe: <strong id="jk-bsp-sval">${SPRAY_POS_B.size.toFixed(2)}</strong></label>
        <input type="range" id="jk-bsp-s" min="5" max="80" value="${SPRAY_POS_B.size * 100}" style="width:100%;margin:3px 0 8px;accent-color:#a8c87e;">
        <label>↺ Drehen: <strong id="jk-bsp-rval">${SPRAY_POS_B.r}°</strong></label>
        <input type="range" id="jk-bsp-r" min="-180" max="180" value="${SPRAY_POS_B.r}" style="width:100%;margin:3px 0 10px;accent-color:#a8c87e;">

        <div style="font-weight:600;margin-bottom:4px;color:#c8a46e;">📿 Tasbih (B)</div>
        <label>Links ↔ Rechts: <strong id="jk-btp-xval">${TASBIH_POS_B.x.toFixed(2)}</strong></label>
        <input type="range" id="jk-btp-x" min="0" max="100" value="${TASBIH_POS_B.x * 100}" style="width:100%;margin:3px 0 8px;accent-color:#c8a46e;">
        <label>Oben ↕ Unten: <strong id="jk-btp-yval">${TASBIH_POS_B.y.toFixed(2)}</strong></label>
        <input type="range" id="jk-btp-y" min="0" max="100" value="${TASBIH_POS_B.y * 100}" style="width:100%;margin:3px 0 8px;accent-color:#c8a46e;">
        <label>📐 Größe: <strong id="jk-btp-sval">${TASBIH_POS_B.size.toFixed(2)}</strong></label>
        <input type="range" id="jk-btp-s" min="5" max="80" value="${TASBIH_POS_B.size * 100}" style="width:100%;margin:3px 0 8px;accent-color:#c8a46e;">
        <label>↺ Drehen: <strong id="jk-btp-rval">${TASBIH_POS_B.r}°</strong></label>
        <input type="range" id="jk-btp-r" min="-180" max="180" value="${TASBIH_POS_B.r}" style="width:100%;margin:3px 0 8px;accent-color:#c8a46e;">

        <div id="jk-bpos-result" style="margin-top:6px;font-size:11px;color:#fff;background:#333;padding:6px 8px;border-radius:6px;">
          B-LAT: x:${NAME_POS_B.x.toFixed(2)} y:${NAME_POS_B.y.toFixed(2)} r:${NAME_POS_B.r}° s:${NAME_POS_B.size.toFixed(2)}<br>
          BOW: x:${BOW_POS.x.toFixed(2)} y:${BOW_POS.y.toFixed(2)} w:${BOW_POS.w.toFixed(2)} h:${BOW_POS.h.toFixed(2)}<br>
          B-SPR: x:${SPRAY_POS_B.x.toFixed(2)} y:${SPRAY_POS_B.y.toFixed(2)} s:${SPRAY_POS_B.size.toFixed(2)} r:${SPRAY_POS_B.r}°<br>
          B-TAS: x:${TASBIH_POS_B.x.toFixed(2)} y:${TASBIH_POS_B.y.toFixed(2)} s:${TASBIH_POS_B.size.toFixed(2)} r:${TASBIH_POS_B.r}°
        </div>
        </div>
      `;
      document.body.appendChild(ui);

      function updateResult() {
        document.getElementById('jk-pos-result').innerHTML =
          `LAT: x:${NAME_POS.x.toFixed(2)} y:${NAME_POS.y.toFixed(2)} r:${NAME_POS.r}° s:${NAME_POS.size.toFixed(2)}<br>ARB: x:${ARABIC_POS.x.toFixed(2)} y:${ARABIC_POS.y.toFixed(2)} r:${ARABIC_POS.r}° s:${ARABIC_POS.size.toFixed(3)}<br>SPR: x:${SPRAY_POS.x.toFixed(2)} y:${SPRAY_POS.y.toFixed(2)} s:${SPRAY_POS.size.toFixed(2)} r:${SPRAY_POS.r}°<br>TAS: x:${TASBIH_POS.x.toFixed(2)} y:${TASBIH_POS.y.toFixed(2)} s:${TASBIH_POS.size.toFixed(2)} r:${TASBIH_POS.r}°`;
      }

      document.getElementById('jk-pos-x').addEventListener('input', function() {
        NAME_POS.x = this.value / 100;
        document.getElementById('jk-pos-xval').textContent = NAME_POS.x.toFixed(2);
        updateResult(); renderCanvas();
      });
      document.getElementById('jk-pos-y').addEventListener('input', function() {
        NAME_POS.y = this.value / 100;
        document.getElementById('jk-pos-yval').textContent = NAME_POS.y.toFixed(2);
        updateResult(); renderCanvas();
      });
      document.getElementById('jk-pos-r').addEventListener('input', function() {
        NAME_POS.r = parseFloat(this.value);
        document.getElementById('jk-pos-rval').textContent = NAME_POS.r + '°';
        updateResult(); renderCanvas();
      });
      document.getElementById('jk-pos-s').addEventListener('input', function() {
        NAME_POS.size = this.value / 100;
        document.getElementById('jk-pos-sval').textContent = NAME_POS.size.toFixed(2);
        updateResult(); renderCanvas();
      });
      document.getElementById('jk-apos-x').addEventListener('input', function() {
        ARABIC_POS.x = this.value / 100;
        document.getElementById('jk-apos-xval').textContent = ARABIC_POS.x.toFixed(2);
        updateResult(); renderCanvas();
      });
      document.getElementById('jk-apos-y').addEventListener('input', function() {
        ARABIC_POS.y = this.value / 100;
        document.getElementById('jk-apos-yval').textContent = ARABIC_POS.y.toFixed(2);
        updateResult(); renderCanvas();
      });
      document.getElementById('jk-apos-r').addEventListener('input', function() {
        ARABIC_POS.r = parseFloat(this.value);
        document.getElementById('jk-apos-rval').textContent = ARABIC_POS.r + '°';
        updateResult(); renderCanvas();
      });
      document.getElementById('jk-apos-s').addEventListener('input', function() {
        ARABIC_POS.size = this.value / 100;
        document.getElementById('jk-apos-sval').textContent = ARABIC_POS.size.toFixed(3);
        updateResult(); renderCanvas();
      });
      document.getElementById('jk-tpos-x').addEventListener('input', function() {
        TASBIH_POS.x = this.value / 100;
        document.getElementById('jk-tpos-xval').textContent = TASBIH_POS.x.toFixed(2);
        updateResult(); renderCanvas();
      });
      document.getElementById('jk-tpos-y').addEventListener('input', function() {
        TASBIH_POS.y = this.value / 100;
        document.getElementById('jk-tpos-yval').textContent = TASBIH_POS.y.toFixed(2);
        updateResult(); renderCanvas();
      });
      document.getElementById('jk-tpos-s').addEventListener('input', function() {
        TASBIH_POS.size = this.value / 100;
        document.getElementById('jk-tpos-sval').textContent = TASBIH_POS.size.toFixed(2);
        updateResult(); renderCanvas();
      });
      document.getElementById('jk-spos-x').addEventListener('input', function() {
        SPRAY_POS.x = this.value / 100;
        document.getElementById('jk-spos-xval').textContent = SPRAY_POS.x.toFixed(2);
        updateResult(); renderCanvas();
      });
      document.getElementById('jk-spos-y').addEventListener('input', function() {
        SPRAY_POS.y = this.value / 100;
        document.getElementById('jk-spos-yval').textContent = SPRAY_POS.y.toFixed(2);
        updateResult(); renderCanvas();
      });
      document.getElementById('jk-spos-s').addEventListener('input', function() {
        SPRAY_POS.size = this.value / 100;
        document.getElementById('jk-spos-sval').textContent = SPRAY_POS.size.toFixed(2);
        updateResult(); renderCanvas();
      });
      document.getElementById('jk-spos-r').addEventListener('input', function() {
        SPRAY_POS.r = parseFloat(this.value);
        document.getElementById('jk-spos-rval').textContent = SPRAY_POS.r + '°';
        updateResult(); renderCanvas();
      });
      document.getElementById('jk-tpos-r').addEventListener('input', function() {
        TASBIH_POS.r = parseFloat(this.value);
        document.getElementById('jk-tpos-rval').textContent = TASBIH_POS.r + '°';
        updateResult(); renderCanvas();
      });

      function updateBResult() {
        document.getElementById('jk-bpos-result').innerHTML =
          `B-LAT: x:${NAME_POS_B.x.toFixed(2)} y:${NAME_POS_B.y.toFixed(2)} r:${NAME_POS_B.r}° s:${NAME_POS_B.size.toFixed(2)} xR:${NAME_POS_B.xRight.toFixed(2)} xL:${NAME_POS_B.xLeft.toFixed(2)}<br>BOW: x:${BOW_POS.x.toFixed(2)} y:${BOW_POS.y.toFixed(2)} w:${BOW_POS.w.toFixed(2)} h:${BOW_POS.h.toFixed(2)}<br>B-SPR: x:${SPRAY_POS_B.x.toFixed(2)} y:${SPRAY_POS_B.y.toFixed(2)} s:${SPRAY_POS_B.size.toFixed(2)} r:${SPRAY_POS_B.r}°<br>B-TAS: x:${TASBIH_POS_B.x.toFixed(2)} y:${TASBIH_POS_B.y.toFixed(2)} s:${TASBIH_POS_B.size.toFixed(2)} r:${TASBIH_POS_B.r}°`;
      }
      document.getElementById('jk-bow-x').addEventListener('input', function() {
        BOW_POS.x = this.value / 100;
        document.getElementById('jk-bow-xval').textContent = BOW_POS.x.toFixed(2);
        updateBResult(); renderCanvas();
      });
      document.getElementById('jk-bow-y').addEventListener('input', function() {
        BOW_POS.y = this.value / 100;
        document.getElementById('jk-bow-yval').textContent = BOW_POS.y.toFixed(2);
        updateBResult(); renderCanvas();
      });
      document.getElementById('jk-bow-w').addEventListener('input', function() {
        BOW_POS.w = this.value / 100;
        document.getElementById('jk-bow-wval').textContent = BOW_POS.w.toFixed(2);
        updateBResult(); renderCanvas();
      });
      document.getElementById('jk-bow-h').addEventListener('input', function() {
        BOW_POS.h = this.value / 100;
        document.getElementById('jk-bow-hval').textContent = BOW_POS.h.toFixed(2);
        updateBResult(); renderCanvas();
      });
      document.getElementById('jk-bnp-x').addEventListener('input', function() {
        NAME_POS_B.x = this.value / 100;
        document.getElementById('jk-bnp-xval').textContent = NAME_POS_B.x.toFixed(2);
        updateBResult(); renderCanvas();
      });
      document.getElementById('jk-bnp-y').addEventListener('input', function() {
        NAME_POS_B.y = this.value / 100;
        document.getElementById('jk-bnp-yval').textContent = NAME_POS_B.y.toFixed(2);
        updateBResult(); renderCanvas();
      });
      document.getElementById('jk-bnp-r').addEventListener('input', function() {
        NAME_POS_B.r = parseFloat(this.value);
        document.getElementById('jk-bnp-rval').textContent = NAME_POS_B.r + '°';
        updateBResult(); renderCanvas();
      });
      document.getElementById('jk-bnp-s').addEventListener('input', function() {
        NAME_POS_B.size = this.value / 100;
        document.getElementById('jk-bnp-sval').textContent = NAME_POS_B.size.toFixed(2);
        updateBResult(); renderCanvas();
      });
      document.getElementById('jk-bnp-xr').addEventListener('input', function() {
        NAME_POS_B.xRight = this.value / 100;
        document.getElementById('jk-bnp-xrval').textContent = NAME_POS_B.xRight.toFixed(2);
        updateBResult(); renderCanvas();
      });
      document.getElementById('jk-bnp-xl').addEventListener('input', function() {
        NAME_POS_B.xLeft = this.value / 100;
        document.getElementById('jk-bnp-xlval').textContent = NAME_POS_B.xLeft.toFixed(2);
        updateBResult(); renderCanvas();
      });
      document.getElementById('jk-bsp-x').addEventListener('input', function() {
        SPRAY_POS_B.x = this.value / 100;
        document.getElementById('jk-bsp-xval').textContent = SPRAY_POS_B.x.toFixed(2);
        updateBResult(); renderCanvas();
      });
      document.getElementById('jk-bsp-y').addEventListener('input', function() {
        SPRAY_POS_B.y = this.value / 100;
        document.getElementById('jk-bsp-yval').textContent = SPRAY_POS_B.y.toFixed(2);
        updateBResult(); renderCanvas();
      });
      document.getElementById('jk-bsp-s').addEventListener('input', function() {
        SPRAY_POS_B.size = this.value / 100;
        document.getElementById('jk-bsp-sval').textContent = SPRAY_POS_B.size.toFixed(2);
        updateBResult(); renderCanvas();
      });
      document.getElementById('jk-btp-x').addEventListener('input', function() {
        TASBIH_POS_B.x = this.value / 100;
        document.getElementById('jk-btp-xval').textContent = TASBIH_POS_B.x.toFixed(2);
        updateBResult(); renderCanvas();
      });
      document.getElementById('jk-btp-y').addEventListener('input', function() {
        TASBIH_POS_B.y = this.value / 100;
        document.getElementById('jk-btp-yval').textContent = TASBIH_POS_B.y.toFixed(2);
        updateBResult(); renderCanvas();
      });
      document.getElementById('jk-btp-s').addEventListener('input', function() {
        TASBIH_POS_B.size = this.value / 100;
        document.getElementById('jk-btp-sval').textContent = TASBIH_POS_B.size.toFixed(2);
        updateBResult(); renderCanvas();
      });
      document.getElementById('jk-bsp-r').addEventListener('input', function() {
        SPRAY_POS_B.r = parseFloat(this.value);
        document.getElementById('jk-bsp-rval').textContent = SPRAY_POS_B.r + '°';
        updateBResult(); renderCanvas();
      });
      document.getElementById('jk-btp-r').addEventListener('input', function() {
        TASBIH_POS_B.r = parseFloat(this.value);
        document.getElementById('jk-btp-rval').textContent = TASBIH_POS_B.r + '°';
        updateBResult(); renderCanvas();
      });
  }

  // ── Start ─────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
